import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import DeleteOrderModal from '@pages/OrganizedSales/CreateOrders/PopupModal/CancelOrderModal';
import { useEffect, useMemo, useRef, useState } from 'react';
import DeclineOrderModal from '@pages/OrganizedSales/CreateOrders/PopupModal/DeclineOrderModal';
import moment from 'moment';
import { RootState } from 'app/store';
import { useDispatch, useSelector } from 'react-redux';
import OrderStatusActionStaff, { EStaffsActionMode, IStaffsActionEvent } from './OrderStatusActionStaff';
import Helpers from 'helpers/Helpers';
import OrderManagerApi, { TTypeStatusAPI } from 'apis/api/OrderManager';
import { Tooltip, message } from 'antd';
import { getAllTechnicianZone, getUsersTechnician, updatePageLoadingApi } from '@slice/select.slice';
import { addCreateOrders, getDetailOfOrder, updateOpenCreateModal } from '@slice/orderManager.slice';
import { TTypeStatusMsg } from '@models/OrderManager';
import { ThunkDispatch } from '@reduxjs/toolkit';
import ViewImages from './ModalUpdateImages/ViewImages';
import UploadImages from './UploadImages';
import { canEditCreatorImages } from './ModalUpdateImages/orderImageUtils';
import ConfirmOrderModal from '../PopupModal/ConfirmOrderModal';
import { useStoreUpdateOrder } from '../store';
import { getAllOMConfig } from '@slice/adminConfig.slice';
import { useBaseOrderStore } from '../layoutContentUWR/BaseOrder/BaseOrderStore';
import {
  findProductsNeedConfirm,
  fixEmptyHanDangKiem,
  getSetInfo,
  isNeedRequestUpdateMsg,
  needsCreatorConfirm,
  isUpgradeFinishNoSummaryOn,
  resolveRequestUpdateSource
} from '../common/Hooks/hook/upgradeOrder';
import { confirmRequestUpdate } from '../common/confirmRequestUpdate';
import { pickUpgradeSummary } from './hook/pickUpgradeSummary';
// import UtilOrder from '../utilOrder';

export default function StatusOrder({
  isQAction,
  checkFormDetail,
  setErrorFields,
  valueVAT,
  mst,
  companyName,
  emailVAT,
  address,
  type,
  isChangeTypeOrder,
  timeEndFees,
  timeStartFees,
  detailTraHangSets,
  detailThuNos,
  ContactSĐT,
  ContactCusName,
  cusName,
  SĐT,
  AddressShip,
  CompanyDevice,
  chiNhanh,
  tienThanhToanNew,
  formData,
  useVAT // check bật tắt checkbox VAT
}: any) {
  const { t } = useTranslation();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const [openCanel, setOpenCancel] = useState<boolean>(false);
  const [openDecline, setOpenDecline] = useState<boolean>(false);
  const uLogin = useSelector((state: RootState) => state.user.account);
  const openCodeCreateModal = useSelector((state: RootState) => state.orderManager.openCodeCreateModal);

  const loadedDataSelect = useSelector((state: RootState) => state.select.loadedData);
  const loadedData = useSelector((state: RootState) => state.admin.loadedData);
  const rowSelected = useSelector((state: RootState) => state.orderManager.orderSelect);
  // const detailBase = useSelector((state: RootState) => state.orderManager.detailBase); // huỷ không dùng
  const detailErrors = useSelector((state: RootState) => state.orderManager.detailErrors);
  const detailUpgrades = useSelector((state: RootState) => state.orderManager.detailUpgrades);
  const detailReplace = useSelector((state: RootState) => state.orderManager.detailReplace);
  const detailPayFees = useSelector((state: RootState) => state.orderManager.detailPayFees);
  const detailChenhLechs = useSelector((state: RootState) => state.orderManager.detailChenhLechs);

  const detailDLLG = useSelector((state: RootState) => state.orderManager.detailDLLG);
  const detailTraHang = useSelector((state: RootState) => state.orderManager.detailTraHang);

  const { methods, setInputError } = useBaseOrderStore();

  const configOM = useSelector((state: RootState) => state.admin.configOM);

  const payMethod = useSelector((state: RootState) => state.orderManager.payMethod); // PTTT
  const payedMoney = useSelector((state: RootState) => state.orderManager.payedMoney); // Tiền thực thu
  const payedBankingMoney = useSelector((state: RootState) => state.orderManager.payedBankingMoney); // Tiền CK thực tế
  const productSetDataHaveDetails = useSelector((state: RootState) => state.createOrder.productSetDataHaveDetails);
  const payWillMoney = useSelector((state: RootState) => state.orderManager.payWillMoney); // Tiền thanh toán

  const otherCost = useSelector((state: RootState) => state.orderManager.otherCost);
  // const ariseCost = useSelector((state: RootState) => state.orderManager.ariseCost);
  const timePostPone = useSelector((state: RootState) => state.orderManager.timePostPone);

  const productCategoryPMP = useSelector((state: RootState) => state.createOrder.listProductMixDataPaging);
  const productCategoryPMS = useSelector((state: RootState) => state.createOrder.dataProductMixSearch);
  const [numDay, setNumDay] = useState<number>(31);
  const [isPrioritized, setIsPrioritized] = useState<boolean>(false);
  const [CreateTime, setCreateTime] = useState<string | null>(null);
  const [WorkTime, setWordTime] = useState<string | null>(null);
  const [DoneTime, setDoneTime] = useState<string | null>(null);
  const [staffCreate, setStaffCreate] = useState<string>('');
  const [staffConfirm, setStaffConfirm] = useState<string>('');
  const [staffWork, setStaffWork] = useState<string>('');
  const [staffApprove, setStaffApprove] = useState<string>('');
  const [typeOrder, setTypeOrder] = useState<string>(''); // type là cần full text còn key mới là cần id
  const [typeKeyOrder, setTypeKeyOrder] = useState<number>(0); // type là cần full text còn key mới là cần id
  const [modeAction, setModeAction] = useState<EStaffsActionMode[]>([EStaffsActionMode.UNKNOWN]);
  const [timeData, setTimeData] = useState<any>();
  const dataDeviceUpdateOrder = useStoreUpdateOrder(state => state);
  const listProMix = [...productCategoryPMP, ...productCategoryPMS];
  const refPrioritized = useRef<boolean>(false);

  useEffect(() => {
    !loadedData.OMConfigLoaded && dispatch(getAllOMConfig()); // tạo đơn lấy all dữ liệu select bộ
  }, []);

  useMemo(() => {
    return configOM.map(e => {
      if (e.key === 'TimeUpdateAfterComplete') {
        return setTimeData(Number(e.data));
      }
    });
  }, [configOM]);

  // khi component được bật riêng lẻ (mở drawer thao tác nhanh thì sử dụng)
  const proccessDetailBase = (detail: any[], hasEx?: boolean) => {
    const listProMix = [...productCategoryPMP, ...productCategoryPMS];
    const listDetails = [];

    for (let i = 0; i < detail?.length; i++) {
      // kiểm tra có trùng mã sản phẩm + mã bộ trong listDetails không???
      if (detail[i].serial == '' && detail[i].phone == '') {
        const checkExist = listDetails.find(
          dtl => dtl.maSanPham + '' + dtl.maBo + '' == detail[i].maSanPham + '' + detail[i].maBo + ''
        );

        if (checkExist) {
          checkExist['amount'] = (checkExist['amount'] || 1) + 1;
          continue;
        }

        listDetails.push({
          ...detail[i], // giữ lại cái cũ
          setName: listProMix.find(proMix => proMix.maSanPham == detail[i]?.maBo)?.nameDisplay || null,
          // isRequireSP: findPM?.input || 0,
          amount: detail[i].amount || 1
        });

        continue;
      }

      listDetails.push({
        ...detail[i], // giữ lại cái cũ
        setName: listProMix.find(proMix => proMix.maSanPham == detail[i]?.maBo)?.nameDisplay || null,
        amount: 1
        // isRequireSP: findPM?.input || 0
      });
    }

    return listDetails.sort((a, b) => a.amount - b.amount) || [];
  };

  useEffect(() => {
    if (isQAction) {
      !loadedDataSelect.techStaffLoaded && dispatch(getUsersTechnician());
      if (!loadedDataSelect.technicianZoneLoaded) {
        dispatch(getAllTechnicianZone());
      }
    }
  }, [isQAction]);

  useEffect(() => {
    // console.log('rowSelected ', rowSelected);
    if (rowSelected) {
      setTypeOrder(rowSelected.orderType?.name); // cần name còn key là cần id
      setTypeKeyOrder(rowSelected.orderType?.id);

      rowSelected.times?.thoiGianTao &&
        setCreateTime(Helpers.ConvertTimeUTCToStringLocal(rowSelected.times.thoiGianTao));
      rowSelected.times?.thoiGianBatDau &&
        setWordTime(Helpers.ConvertTimeUTCToStringLocal(rowSelected.times.thoiGianBatDau));
      rowSelected.times?.thoiGianHoanThanh &&
        setDoneTime(Helpers.ConvertTimeUTCToStringLocal(rowSelected.times.thoiGianHoanThanh));

      setStaffCreate(rowSelected.staffCreate ? 'NV tạo đơn' : 'Không xác định');
      setStaffConfirm(rowSelected.staffOperate ? 'NV điều hành' : 'Không xác định');
      setStaffApprove(rowSelected.staffApprove ? 'NV duyệt đơn' : 'Không xác định');
      setStaffWork('Không xác định');

      setIsPrioritized(rowSelected.isPrioritized);
      refPrioritized.current = rowSelected.isPrioritized;

      // ROOT ADMIN có toàn quyền trị
      // phần xử lý trạng thái đơn để đặt mode cho status Component
      // này quan trọng lắm nha k được đẻ sai hay sửa lum tung vô nha.. chú ý kỹ vô
      switch (rowSelected?.status?.statusValue) {
        case '1': // đơn mới tạo
          setModeAction([
            EStaffsActionMode.ROOT,
            EStaffsActionMode.ADMIN,
            EStaffsActionMode.ACCOUNTANT,
            EStaffsActionMode.SALE,
            EStaffsActionMode.CUSTOMERSERVICE
          ]);
          break;
        case '3': // bị hẹn hoặc khách kêu vấn đề gì đó k thực hiện tiếp thì.. điều hành quản + kd + cskh
          setModeAction([
            EStaffsActionMode.ROOT,
            EStaffsActionMode.ADMIN,
            EStaffsActionMode.OPERATING,
            EStaffsActionMode.SALE,
            EStaffsActionMode.CUSTOMERSERVICE
          ]);
          break;

        case '4': // đơn hoàn tất thì kế toán có thể vào để cập nhật tiền (phần này chắc để làm bên mục payment) , cho đh vô để cập nhật sau hoàm tất
          setModeAction([
            EStaffsActionMode.ROOT,
            EStaffsActionMode.ADMIN,
            EStaffsActionMode.OPERATING,
            EStaffsActionMode.ACCOUNTANT,
            EStaffsActionMode.CUSTOMERSERVICE
          ]);
          break;

        case '12': // đơn hợp lệ // khi nào đơn kết thúc thì mới end chuyện điều phối || người tạo đơn vào để hoãn đơn (hơi lạ đúng thì chỉ để điều hành hoãn)
          setModeAction([
            EStaffsActionMode.ROOT,
            EStaffsActionMode.ADMIN,
            EStaffsActionMode.OPERATING,
            EStaffsActionMode.SALE,
            EStaffsActionMode.CUSTOMERSERVICE
          ]);
          break;
        // case '13': // đơn do kỹ thuật huỷ || hiện tại khi kỹ thuật huỷ thì coi như k xử lý chỉ lưu tại sao k nhận làm để đh biết
        //   setModeAction([EStaffsActionMode.OPERATING]);
        //   break;
        case '6': // bị từ chối công nợ thì cho vào để huỷ hay là reorder lại đơn
          setModeAction([
            EStaffsActionMode.ROOT,
            EStaffsActionMode.ADMIN,
            EStaffsActionMode.SALE,
            EStaffsActionMode.CUSTOMERSERVICE
          ]);
          break;

        case '2': // đơn đang thực hiện thì vẫn điều phối lại được luôn + kthuat thao tác  || người tạo đơn vào để hoãn đơn (hơi lạ đúng thì chỉ để điều hành hoãn)
          setModeAction([
            EStaffsActionMode.ROOT,
            EStaffsActionMode.ADMIN,
            EStaffsActionMode.OPERATING,
            EStaffsActionMode.TECHNICIAN,
            EStaffsActionMode.SALE,
            EStaffsActionMode.CUSTOMERSERVICE
          ]);
          break;
        case '7': // đơn đã điều phối thì vẫn có thể điều phối lại + kthuat thao tác  || người tạo đơn vào để hoãn đơn (hơi lạ đúng thì chỉ để điều hành hoãn)
          setModeAction([
            EStaffsActionMode.ROOT,
            EStaffsActionMode.ADMIN,
            EStaffsActionMode.OPERATING,
            EStaffsActionMode.TECHNICIAN,
            EStaffsActionMode.SALE,
            EStaffsActionMode.CUSTOMERSERVICE
          ]);
          break;
        case '111': // đơn đã điều phối thì vẫn có thể điều phối lại + kthuat thao tác  || người tạo đơn vào để hoãn đơn (hơi lạ đúng thì chỉ để điều hành hoãn)
          setModeAction([
            EStaffsActionMode.ROOT,
            EStaffsActionMode.ADMIN,
            EStaffsActionMode.OPERATING,
            EStaffsActionMode.TECHNICIAN,
            EStaffsActionMode.UNKNOWN
          ]);
          break;

        default:
          break;
      }
    }
  }, [rowSelected]);

  const callBackDelete = (data: any) => {
    console.log('Cancel order > setState is Cancel Order and reCall api');
  };
  const callBackDecline = (data: any) => {
    console.log('Decline order > setState is Decline Order and reCall api');
  };

  const showMessage = (msg?: string, type?: string) => {
    if (type === 'error') {
      message.error(msg, 10);
    } else {
      message.success(msg);
    }
  };

  const handleRequestOrder = async (type?: any, maDonHang?: string, typeMsg?: TTypeStatusMsg) => {
    try {
      dispatch(updatePageLoadingApi(true));
      await OrderManagerApi.RequestOrder(type, maDonHang).then(res => {
        console.log('res', res, !res.data.error);
        if (!res.data.error) {
          showMessage(t(`OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Success.${typeMsg}`), 'success');

          dispatch(getDetailOfOrder({ maDonHang: maDonHang, typeOrder: rowSelected.orderType.id }));
          // setTimeout(() => {
          //   dispatch(getDetailOfOrder({ maDonHang: data.maDonHang, typeOrder: rowSelected.orderType.id })); // gọi lên lấy data mới luôn !!
          // }, 250);
        } else {
          // SubMsg
          showMessage(res.data.message);
        }
        setTimeout(() => {
          dispatch(updatePageLoadingApi(false));
        }, 250);
      });
    } catch (error) {
      console.log(error);
      dispatch(updatePageLoadingApi(false));
    }
  };

  // Đơn đã gửi yêu cầu cập nhật (yeuCauChinhSua = 1) -> chỉ nhắc chờ, không hỏi gửi lại
  const warnWaitingCreator = (products: string[]) =>
    message.warning(
      `Sản phẩm ${[...new Set(products)].join(', ')} chưa được bộ phận tạo đơn xác nhận. ` +
        'Đơn đã gửi yêu cầu cập nhật, đang chờ người tạo đơn xác nhận',
      10
    );

  // KT xác nhận trong modal mới gửi YeuCauChinhSua
  const askRequestUpdateOrder = (maDonHang: string, source: string | string[]) =>
    confirmRequestUpdate(source, async () => {
      const res = await OrderManagerApi.RequestOrder('YeuCauChinhSua', maDonHang);
      if (!res.data.error) {
        message.success('Đã gửi yêu cầu cập nhật đơn hàng');
        dispatch(getDetailOfOrder({ maDonHang, typeOrder: rowSelected.orderType.id }));
      } else {
        showMessage(`Gửi yêu cầu cập nhật đơn hàng thất bại: ${res.data.message}`, 'error');
      }
    });

  const handleActionStaff = async (
    type?: TTypeStatusAPI,
    data?: any,
    typeMsg?: TTypeStatusMsg,
    maDonHang?: any,
    typeRequest?: any
  ) => {
    console.log('handleActionStaff', type, data, maDonHang, typeRequest);
    try {
      dispatch(updatePageLoadingApi(true));
      await OrderManagerApi.ActionStatusOrder(type, data).then(res => {
        console.log('res', res, !res.data.error);
        if (!res.data.error) {
          if (typeRequest === 'pauseRequest') {
            const text: any = typeMsg + 'PauseOrder';
            showMessage(t(`OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Success.${typeMsg}`), 'success');
            // dispatch(updateReqReGetOrder(true)); // chỉ update đơn đang thao tác !!
            setTimeout(() => {
              dispatch(getDetailOfOrder({ maDonHang: data.maDonHang, typeOrder: rowSelected.orderType.id })); // gọi lên lấy data mới luôn !!
            }, 250);
          } else if (typeRequest === 'checkRequest') {
            // showMessage(t(`OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Success.${typeMsg}`), 'success');
            // dispatch(updateReqReGetOrder(true)); // chỉ update đơn đang thao tác !!
            // setTimeout(() => {
            //   dispatch(getDetailOfOrder({ maDonHang: data.maDonHang, typeOrder: rowSelected.orderType.id })); // gọi lên lấy data mới luôn !!
            // }, 250);

            const text: any = typeMsg + 'RequestOrder';
            handleRequestOrder('YeuCauChinhSua', maDonHang, text);
          } else {
            showMessage(t(`OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Success.${typeMsg}`), 'success');
            // dispatch(updateReqReGetOrder(true)); // chỉ update đơn đang thao tác !!
            setTimeout(() => {
              dispatch(getDetailOfOrder({ maDonHang: data.maDonHang, typeOrder: rowSelected.orderType.id })); // gọi lên lấy data mới luôn !!
            }, 250);
          }
        } else if (isNeedRequestUpdateMsg(res.data.message) && rowSelected?.yeuCauChinhSua == 1) {
          message.warning(`${res.data.message}. Đơn đã gửi yêu cầu cập nhật, đang chờ người tạo đơn xác nhận`, 10);
        } else if (isNeedRequestUpdateMsg(res.data.message) && typeRequest !== 'checkRequest') {
          // KT đổi/thêm SP mà bên tạo đơn chưa xác nhận -> hỏi KT có gửi yêu cầu cập nhật không.
          // checkRequest = lần gọi đã đi kèm gửi yêu cầu cập nhật -> không mở lại modal (tránh lặp), rơi xuống báo lỗi thường
          askRequestUpdateOrder(
            maDonHang || data?.maDonHang,
            resolveRequestUpdateSource(res.data.message, rowSelected, productSetDataHaveDetails)
          );
        } else {
          // SubMsg
          showMessage(
            t(`OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Error.${typeMsg}`) + '. Err! ' + res.data.message ||
              '',
            'error'
          );
        }
        setTimeout(() => {
          dispatch(updatePageLoadingApi(false));
        }, 250);
      });
    } catch (error) {
      console.log(error);
      dispatch(updatePageLoadingApi(false));
      showMessage(t(`OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Error.${typeMsg}`), 'error');
    }
  };

  // function mergeErrorItems(errorItems) {
  //   const merged = [];

  //   for (const item of errorItems) {
  //     // Tìm xem đã tồn tại object cùng id + oldSerial + registrationPlate chưa
  //     const existIndex = merged.findIndex(
  //       m => m.id === item.id && m.oldSerial === item.oldSerial && m.registrationPlate === item.registrationPlate
  //     );

  //     if (existIndex === -1) {
  //       // Chưa có → push mới
  //       merged.push({ ...item });
  //     } else {
  //       // Đã có → merge
  //       const existing = merged[existIndex];

  //       // Gộp diagnosis
  //       if (item.diagnosis) {
  //         if (existing.diagnosis) {
  //           existing.diagnosis += ';' + item.diagnosis;
  //         } else {
  //           existing.diagnosis = item.diagnosis;
  //         }
  //       }

  //       // Gộp handling
  //       if (item.handling) {
  //         if (existing.handling) {
  //           existing.handling += ';' + item.handling;
  //         } else {
  //           existing.handling = item.handling;
  //         }
  //       }

  //       // Gộp details (nếu có)
  //       if (Array.isArray(item.details) && item.details.length > 0) {
  //         if (!Array.isArray(existing.details)) existing.details = [];
  //         existing.details.push(...item.details);
  //       }

  //       // Ưu tiên field không rỗng
  //       for (const key of Object.keys(item)) {
  //         if (existing[key] === '' || existing[key] === null || existing[key] === undefined) {
  //           existing[key] = item[key];
  //         }
  //       }

  //       merged[existIndex] = existing;
  //     }
  //   }

  //   return merged;
  // }

  // chỉ dành cho nv kto cập nhật lại tiền cho đơn hàng
  const updateLastPayment = async (body: any) => {
    try {
      body &&
        (await OrderManagerApi.UpdatePayment(body).then(res => {
          if (!res.data.error) {
            message.success(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.UpdateMoneyPayed.Success'));
            // dispatch(updateReqReGetOrder(true)); // chỉ update đơn đang thao tác !!
            dispatch(getDetailOfOrder({ maDonHang: body.maDonHang, typeOrder: rowSelected.orderType.id })); // gọi lên lấy data mới luôn !!
          } else {
            message.error(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.UpdateMoneyPayed.Error'));
          }
        }));
    } catch (error) {
      console.log('error');
    }
  };

  const productMix = useMemo(() => {
    return [...productCategoryPMP, ...productCategoryPMS];
  }, [productCategoryPMP, productCategoryPMS]);

  const listCateOrder = useMemo(() => {
    if (dataDeviceUpdateOrder.devices.length !== 0) {
      return [...dataDeviceUpdateOrder.devices[0]];
    }
    return [];
  }, [dataDeviceUpdateOrder.devices]);

  const actionStaffsEvents: IStaffsActionEvent = {
    onClick: (e?: any) => {
      console.log('onClick', e);
    },
    // nv Kế toán
    declineOrder: (e?: any) => {
      // console.log('declineOrder', e);

      if (e.length == 0) {
        checkFormDetail && checkFormDetail();
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.NoteRequire'), 'error');
        return;
      }

      const body = {
        maDonHang: rowSelected.maDonHang,
        isApproved: false,
        note: e || ''
      };

      handleActionStaff('Approve', body, 'NotApproved');
    },
    approveOrder: (e?: any) => {
      // console.log('approveOrder', e);
      const body = {
        maDonHang: rowSelected.maDonHang,
        isApproved: true,
        note: e || '',
        hinhThucThanhToan: payMethod || rowSelected.payment.hinhThucThanhToan,
        tienThanhToan: payWillMoney || rowSelected.payment.tienThanhToan || 0,
        tienThucThu: payedMoney || rowSelected.payment.tienThucThu || 0,
        tienDuKien: 0,
        vatAmount: 0
      };
      // 1. Xác định nguồn dữ liệu dựa trên điều kiện
      const dataSource = rowSelected?.orderType?.id === 12 ? detailTraHangSets : rowSelected?.itemDetailsMerg;

      // 2. Chỉ thực hiện map một lần duy nhất
      if (dataSource) {
        body['detailItems'] = dataSource.flatMap(set =>
          (set.details || []).map(item => ({
            // id: item.id || 0,
            id: typeof item.id === 'string' ? 0 : item.id,
            vehicleType: set.vehicleType || '',
            registrationPlate: set.registrationPlate || '',
            maSanPham: item.maSanPham || '',
            serial: item.serial || '',
            companyId: set.companyId || 0,
            doiXe: set.doiXe || '',
            hanDangKiem: '0001-01-01T00:00:00',
            maBo: item.maBo || '',
            phone: item.phone || '',
            cost: item.cost || 0
          }))
        );
      }
      handleActionStaff('Approve', body, 'Approved');
    },
    approveOrderThuNo: (e?: any) => {
      // 1. Lấy danh sách các đơn nợ đã được tích chọn (checked: true)
      // Lưu ý: Dữ liệu nằm trong ThuNoItems[0].inDebtOrderCodes
      const selectedDebtOrders = rowSelected.ThuNoItems?.[0]?.inDebtOrderCodes?.filter(item => item.checked) || [];

      // 2. Khởi tạo Body
      const body = {
        maDonHang: rowSelected.maDonHang,
        isApproved: true,
        note: e || '',
        hinhThucThanhToan: payMethod || rowSelected.payment?.hinhThucThanhToan || 'Tiền mặt',
        tienThanhToan: payWillMoney || rowSelected.payment?.tienThanhToan || 0,
        tienThucThu: payedMoney || rowSelected.payment?.tienThucThu || 0,
        tienDuKien: 0,
        vatAmount: rowSelected.payment?.vatAmount || 0,

        // items: Chứa thông tin tài chính của từng dòng nợ
        items: selectedDebtOrders.map(order => ({
          id: order.id || 0,
          cost: order.tienNo || 0,
          vatValue: order.thuVat || 0,
          priceAfterVat: (order.tienNo || 0) + (order.thuVat || 0)
        })),

        // detailItems: Chứa chi tiết xe/thiết bị của từng đơn nợ
        detailItems: selectedDebtOrders.map(order => ({
          id: order.id || 0,
          vehicleType: order.orderType || '', // Ví dụ: "Lắp mới"
          registrationPlate: order.bienSoXe || '',
          maSanPham: '',
          serial: order.serial || '',
          companyId: rowSelected.branchInfo?.id || 0,
          doiXe: '',
          hanDangKiem: '0001-01-01T00:00:00',
          maBo: order.maDonHang || '', // Gán mã đơn nợ cũ vào maBo để đối soát
          phone: rowSelected.customerInfo?.customerPhone || '',
          cost: order.tienNo || 0
        }))
      };

      // 3. Gọi action xử lý (Bỏ comment khi chạy thực tế)
      handleActionStaff('ApproveDebtOrder', body, 'Approved');
    },
    approveOrderChietKhau: (e?: any, isApproved: boolean = true) => {
      const body = {
        maDonHang: rowSelected.maDonHang,
        isApproved,
        note: e || ''
      };

      handleActionStaff('ApproveDiscountOrder', body, 'Approved');
    },
    updatePayment: (moneyPayed?: number | null, note?: string) => {
      checkFormDetail && checkFormDetail();
      if (!(moneyPayed >= 0) || moneyPayed == null) {
        showMessage(
          t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.UpdateMoneyPayed.ErrorInput'),
          'error'
        );

        const errorFeilds = [
          {
            name: 'paymented',
            errors: [t('Input.FieldError.RequireText')]
          }
        ];
        setErrorFields && setErrorFields(errorFeilds);

        return;
      }

      const body = {
        maDonHang: rowSelected.maDonHang,
        tienThucThu: moneyPayed, // tiền này nhập tay vào k lấy chỗ nào khác
        orderVat: {
          tenCongTy: companyName || rowSelected?.orderVat?.tenCongTy,
          mst: mst || rowSelected?.orderVat?.mst,
          address: address || rowSelected?.orderVat?.address,
          vatValue: valueVAT != null && valueVAT != undefined ? valueVAT : rowSelected?.orderVat?.vatValue,
          email: emailVAT || rowSelected?.orderVat?.email
        },
        note: note || ''
      };
      // console.log('updatePayment', moneyPayed, body);
      moneyPayed >= 0 && updateLastPayment(body);
    },
    // nv Điều hành
    assignOrder: (listTech?: any, note?: string) => {
      // console.log('assignOrder', listTech, note);
      const body = {
        maDonHang: rowSelected.maDonHang,
        listStaffExecute: listTech,
        isPrioritized: isPrioritized,
        note: note || ''
      };
      handleActionStaff('Assign', body, 'Assigned');
    },
    restartOrder: (note?: any) => {
      const body = {
        maDonHang: rowSelected.maDonHang,
        note: note || ''
      };
      handleActionStaff('Reprocess', body, 'Reprocessed');
    },
    changePrior: (note?: any) => {
      if (refPrioritized.current === isPrioritized) return;
      const body = {
        maDonHang: rowSelected.maDonHang,
        priority: isPrioritized
      };
      handleActionStaff('OperatorChangePriority', body, 'ChangedPrior');
    },
    editComplete: (note?: any) => {
      // trong đây các đoạn xử lý bị loop với chỗ khác, rảnh thì gom lại cho dễ sửa về sau
      const body = {
        maDonHang: rowSelected.maDonHang,
        itemSummaries: listCateOrder.map(({ giaBanSi, vatValue, ...rest }) => ({
          ...rest,
          cost: giaBanSi,
          vatValue: useVAT ? vatValue || 0 : 0,
          priceAfterVat: useVAT ? giaBanSi + (giaBanSi * vatValue) / 100 : giaBanSi || 0
        })),
        hinhThucThanhToan: payMethod || '',
        note: note || '',
        tienThucThu: payedMoney || 0,
        tienChuyenKhoanThucTe: payedBankingMoney || 0,
        tienDuKien: otherCost || 0,
        tienThanhToan: payWillMoney || 0,
        vatAmount: useVAT ? valueVAT || 0 : 0,
        orderVat: useVAT
          ? {
              tenCongTy: companyName || rowSelected?.orderVat?.tenCongTy,
              mst: mst || rowSelected?.orderVat?.mst,
              address: address || rowSelected?.orderVat?.address,
              vatValue: valueVAT != null && valueVAT != undefined ? valueVAT : rowSelected?.orderVat?.vatValue || '0',
              email: emailVAT || rowSelected?.orderVat?.email
            }
          : {
              tenCongTy: companyName || rowSelected?.orderVat?.tenCongTy,
              mst: mst || rowSelected?.orderVat?.mst,
              address: address || rowSelected?.orderVat?.address,
              vatValue: '',
              email: emailVAT || rowSelected?.orderVat?.email
            }
      };

      if (
        note.length == 0 ||
        address == '' ||
        emailVAT == '' ||
        mst == '' ||
        companyName == '' ||
        address === null ||
        emailVAT === null ||
        mst === null ||
        companyName === null
      ) {
        checkFormDetail && checkFormDetail();
        const errorFeilds = [
          {
            name: 'noticeText',
            errors: [t('Input.FieldError.RequireText')]
          }
        ];
        setErrorFields && setErrorFields(errorFeilds);
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.NoteRequire'), 'error');
        return;
      }
      const errorFeilds = [
        {
          name: 'noticeText',
          errors: []
        }
      ];
      setErrorFields && setErrorFields(errorFeilds);
      let typeStatus = null;
      if (rowSelected?.orderType?.id == 9) {
        const baseSet: any = [];
        for (let i = 0; i < detailDLLG.length; i++) {
          if (detailDLLG[i].details) {
            for (let j = 0; j < detailDLLG[i].details.length; j++) {
              const product = { ...detailDLLG[i].details[j] };
              const objDetail = {
                vehicleType: detailDLLG[i].vehicleType || '',
                registrationPlate: detailDLLG[i].registrationPlate || '',
                companyId: detailDLLG[i].companyId || 0,
                doiXe: detailDLLG[i].doiXe || '',
                hanDangKiem: detailDLLG[i].hanDangKiem || null,
                ...product
              };
              baseSet.push(objDetail);
            }
          } else {
            baseSet.push({
              ...detailDLLG[i]
            });
          }
        }

        body['items'] = baseSet.map(base => ({
          ...base,
          id: base.id || 0,
          hanDangKiem:
            ((moment(base.hanDangKiem)?.isValid() || base.hanDangKiem?._isValid) &&
            Number((base.hanDangKiem + '').split('-')[0]) > 2010
              ? Helpers.ConvertDateToISOString(new Date(base.hanDangKiem || '0001-01-01T23:00:00'), false)
              : null) || null // new Date là bắt buộc và k đặt onlyDate (các date input theo mẫu dùng form đều phải dùng các này),
        }));
        typeStatus = 'UpdateDaiLyLapGiumAfterComplete';
      }
      if (rowSelected?.orderType?.id == 12) {
        // Gán trực tiếp mảng được tạo ra từ flatMap vào body
        // body['items'] = detailTraHangSets.flatMap(set =>
        //   set.details.map(item => ({
        //     id: item.id || 0,
        //     vehicleType: set.vehicleType || '',
        //     registrationPlate: set.registrationPlate || '',
        //     maSanPham: item.maSanPham || '',
        //     serial: item.serial || '',
        //     companyId: set.companyId || 0,
        //     doiXe: set.doiXe || '',
        //     hanDangKiem: set.hanDangKiem,
        //     maBo: item.maBo || '',
        //     phone: item.phone || '',
        //     cost: item.cost || 0
        //   }))
        // );
        if (rowSelected?.orderType?.id == 12) {
          typeStatus = 'UpdateReturnOrderAfterComplete';

          // 1. Xử lý tạo danh sách 'items' (Phẳng hóa dữ liệu từ detailTraHangSets)
          body['items'] = detailTraHangSets?.flatMap(set =>
            (set.details || []).map(item => ({
              id: item.id || 0,
              vehicleType: set.vehicleType || '',
              registrationPlate: set.registrationPlate || '',
              maSanPham: item.maSanPham || '',
              serial: item.serial || '',
              companyId: set.companyId || 0,
              doiXe: set.doiXe || '',
              hanDangKiem: '0001-01-01T23:00:00',
              maBo: item.maBo || '',
              phone: item.phone || '',
              cost: item.cost || 0
            }))
          );

          // 2. Xử lý tạo danh sách 'itemSummaries'
          body['itemSummaries'] = detailTraHangSets?.flatMap(set => {
            // Nếu có details, map qua details
            if (set.details && set.details.length > 0) {
              return set.details.map(item => {
                const cost = Number(item.cost || 0);
                const vatPercent = Number(item.vatValue || 0);
                return {
                  id: item.id || 0,
                  cost: cost,
                  vatValue: vatPercent,
                  priceAfterVat: cost + (cost * vatPercent) / 100
                };
              });
            } else {
              // Nếu không có details, lấy thông tin từ object cha
              const cost = Number(set.cost || 0);
              const vatPercent = Number(set.vatValue || 0);
              return [
                {
                  id: set.id || 0,
                  cost: cost,
                  vatValue: vatPercent,
                  priceAfterVat: cost + (cost * vatPercent) / 100
                }
              ];
            }
          });
        }
        typeStatus = 'UpdateReturnOrderAfterComplete';
      }

      // if (rowSelected?.orderType?.id == 12) {
      //   // Khởi tạo mảng trong object body
      //   body['itemSummaries'] = [];

      //   for (let i = 0; i < detailTraHangSets.length; i++) {
      //     if (detailTraHangSets[i].details) {
      //       for (let j = 0; j < detailTraHangSets[i].details.length; j++) {
      //         const item = detailTraHangSets[i].details[j];

      //         // Tính toán Price After Vat nếu cần (Cost + Tiền VAT)
      //         const cost = Number(item.cost || 0);
      //         const vatPercent = Number(item.vatValue || 0);
      //         const priceAfterVat = cost + (cost * vatPercent) / 100;

      //         // Push vào body theo format yêu cầu
      //         body['itemSummaries'].push({
      //           id: item.id || 0,
      //           cost: cost,
      //           vatValue: vatPercent,
      //           priceAfterVat: priceAfterVat
      //         });
      //       }
      //     } else {
      //       // Trường hợp không có details, lấy thông tin từ item cha
      //       const parentItem = detailTraHangSets[i];
      //       const cost = Number(parentItem.cost || 0);
      //       const vatPercent = Number(parentItem.vatValue || 0);

      //       body['itemSummaries'].push({
      //         id: parentItem.id || 0,
      //         cost: cost,
      //         vatValue: vatPercent,
      //         priceAfterVat: cost + (cost * vatPercent) / 100
      //       });
      //     }
      //   }

      //   typeStatus = 'UpdateReturnOrderAfterComplete';
      // }

      if (rowSelected?.orderType?.id == 3) {
        body['items'] = [];
        const payfees: any[] = [];
        const PayFees = detailPayFees;
        for (let i = 0; i < PayFees.length; i++) {
          const error = { ...detailPayFees[i] };
          payfees.push({ ...error });
          if (PayFees[i].details) {
            for (let j = 0; j < PayFees[i].details.length; j++) {
              const details = { ...PayFees[i].details };
              const objDetails = {
                ...details,
                id: PayFees[i].details[j].id,
                serial: PayFees[i].details[j].serial || '',
                bs: PayFees[i].bs || '',
                maSanPham: PayFees[i].details[j].maSanPham || '',
                companyId: PayFees[i].companyId || '',
                isCamera: PayFees[i].isCamera || false,
                servicePackName: PayFees[i].servicePackName || '',
                cameraCount: PayFees[i].cameraCount || 0,
                cost: PayFees[i].details[j].cost || 0,
                doiXe: PayFees[i].doiXe || '',
                hanDangKiem:
                  ((moment(PayFees[i].hanDangKiem)?.isValid() || PayFees[i].hanDangKiem?._isValid) &&
                  Number((PayFees[i].hanDangKiem + '').split('-')[0]) > 2010
                    ? Helpers.ConvertDateToISOString(new Date(PayFees[i].hanDangKiem || '0001-01-01T23:00:00'), false)
                    : null) || null,
                phone: PayFees[i].details[j].phone || '',
                type: 1
              };
              if (details['amount']) {
                for (let k = 0; k < details['amount']; k++) {
                  objDetails['id'] = 0;
                  payfees.push(objDetails);
                }
                continue;
              }
              payfees.push(objDetails);

              // if (
              //   (detailPayFees[i].details[j].isRequireSP == 1 &&
              //     (detailPayFees[i].details[j].serial?.length == 0 || !detailPayFees[i].details[j].serial)) ||
              //   (detailPayFees[i].details[j].isRequireSP == 2 &&
              //     (detailPayFees[i].details[j].phone?.length == 0 || !detailPayFees[i].details[j].phone))
              // ) {
              //   isNotEnoughData = true;
              // }
            }
          }
        }

        // timeEndFees, timeStartFees;
        body['thoiGianDongPhi'] = timeStartFees
          ? Helpers.ConvertDateToMoment(new Date(timeStartFees))
          : rowSelected.thoiGianDongPhi;
        body['thoiGianHetHan'] = timeEndFees
          ? Helpers.ConvertDateToMoment(new Date(timeEndFees))
          : rowSelected.thoiGianHetHan;
        body['items'] = payfees.map(base => ({
          ...base,
          id: base.id || 0,
          hanDangKiem:
            ((moment(base.hanDangKiem)?.isValid() || base.hanDangKiem?._isValid) &&
            Number((base.hanDangKiem + '').split('-')[0]) > 2010
              ? Helpers.ConvertDateToISOString(new Date(base.hanDangKiem || '0001-01-01T23:00:00'), false)
              : null) || null // new Date là bắt buộc và k đặt onlyDate (các date input theo mẫu dùng form đều phải dùng các này),
        }));
        typeStatus = 'UpdateCollectFeeAfterComplete';
      }
      if (
        rowSelected?.orderType?.id == 1 ||
        rowSelected?.orderType?.id == 2 ||
        rowSelected?.orderType?.id == 6 ||
        rowSelected?.orderType?.id == 10
      ) {
        const detailBase = methods.getValues('BaseItems'); // lấy trực tiếp từ store
        // console.log('finishOrder base', detailBase); // cần map lại data vì có những trường k có
        const bases: any = [];
        for (let i = 0; i < detailBase.length; i++) {
          if (detailBase[i].details) {
            for (let j = 0; j < detailBase[i].details.length; j++) {
              const product = { ...detailBase[i].details[j] };

              const objDetail = {
                ...product,
                vehicleType: detailBase[i].vehicleType || '',
                registrationPlate: detailBase[i].registrationPlate || '',
                companyId: detailBase[i].companyId || 0,
                doiXe: detailBase[i].doiXe || '',
                hanDangKiem: detailBase[i].hanDangKiem || null
              };

              if (product['amount']) {
                for (let k = 0; k < product['amount']; k++) {
                  // objDetail['id'] = product['ids'][k] || 0;
                  bases.push({ ...objDetail });
                  // bases.push({ ...objDetail });
                }
                continue;
              }

              bases.push(objDetail);
            }
          } else {
            bases.push({
              ...detailBase[i]
            });
          }
        }

        body['items'] = bases.map(base => ({
          ...base,
          id: typeof base.id === 'string' ? 0 : base.id, // string là key để form quản lý, gửi thì gửi cái cũ server là số, còn string thì đổi về 0
          vehicleType: base.vehicleType || '',
          registrationPlate: base.registrationPlate || '',
          maSanPham: base.maSanPham || '',
          serial: base.serial || '',
          phone: base.phone || '',
          companyId: base.companyId || 0,
          doiXe: base.doiXe || '',
          hanDangKiem:
            ((moment(base.hanDangKiem)?.isValid() || base.hanDangKiem?._isValid) &&
            Number((base.hanDangKiem + '').split('-')[0]) > 2010
              ? Helpers.ConvertDateToISOString(new Date(base.hanDangKiem || '0001-01-01T23:00:00'), false)
              : null) || null // new Date là bắt buộc và k đặt onlyDate (các date input theo mẫu dùng form đều phải dùng các này),
        }));
        typeStatus = 'UpdateAfterComplete';
      }

      let isNotEnoughData = false;
      if (rowSelected?.orderType?.id == 4 || rowSelected?.orderType?.id == 5) {
        console.log('finishOrder S.chữa | B.Hành', detailErrors); // cần map lại data
        const productMix = [...productCategoryPMP, ...productCategoryPMS];
        const errors = [];

        for (let i = 0; i < detailErrors.length; i++) {
          let diagnosisNew = '';
          let handlingNew = '';

          // 1. Xử lý ErrorItems[i].errors → gom diagnosis/handling
          if (detailErrors[i].errors?.length > 0) {
            const diagnosisNewTemp = [];
            const handlingNewTemp = [];

            for (let k = 0; k < detailErrors[i].errors.length; k++) {
              const errorItem = detailErrors[i].errors[k];
              const newDiagnosis = errorItem.newDiagnosis?.replaceAll(';', '') || '';

              if (Array.isArray(errorItem.newHandling)) {
                const cleanedHandlingArray = errorItem.newHandling
                  .map(h => h?.replaceAll(';', '').trim())
                  .filter(Boolean);

                if (cleanedHandlingArray.length > 0) {
                  handlingNewTemp.push(...cleanedHandlingArray);
                  diagnosisNewTemp.push(...Array(cleanedHandlingArray.length).fill(newDiagnosis));
                } else {
                  diagnosisNewTemp.push(newDiagnosis);
                  handlingNewTemp.push('');
                }
              } else if (typeof errorItem.newHandling === 'string') {
                const cleanedHandling = errorItem.newHandling.replaceAll(';', '').trim();
                if (cleanedHandling) {
                  handlingNewTemp.push(cleanedHandling);
                  diagnosisNewTemp.push(newDiagnosis);
                } else {
                  diagnosisNewTemp.push(newDiagnosis);
                  handlingNewTemp.push('');
                }
              } else {
                if (newDiagnosis) {
                  diagnosisNewTemp.push(newDiagnosis);
                  handlingNewTemp.push('');
                }
              }
            }

            diagnosisNew = diagnosisNewTemp.join(';');
            handlingNew = handlingNewTemp.join(';');
          }

          // 2. Nếu có details → push từng detail
          if (detailErrors[i].details?.length > 0) {
            for (let j = 0; j < detailErrors[i].details.length; j++) {
              const product = { ...detailErrors[i].details[j] };

              const objDetail = {
                ...product,
                id: product.id || 0,
                errorTpye: detailErrors[i].errorTpye || '',
                oldMaSanPham: detailErrors[i].oldMaSanPham || '',
                oldSerial: detailErrors[i].oldSerial || '',
                oldPhone: detailErrors[i].oldPhone || '',
                phenomenon: detailErrors[i].phenomenon || '',
                note: product.note || '',
                diagnosis: diagnosisNew,
                handling: handlingNew,
                cost:
                  product.cost ??
                  (product.newMaSanPham
                    ? productMix.find(p => p.maSanPham === product.newMaSanPham)?.giaBanSi || 0
                    : 0),
                vehicleType: detailErrors[i].vehicleType || '',
                registrationPlate: detailErrors[i].registrationPlate || '',
                companyId: detailErrors[i].companyId || 0,
                doiXe: detailErrors[i].doiXe || '',
                hanDangKiem:
                  ((moment(detailErrors[i].hanDangKiem)?.isValid() || detailErrors[i].hanDangKiem?._isValid) &&
                  Number((detailErrors[i].hanDangKiem + '').split('-')[0]) > 2010
                    ? Helpers.ConvertDateToISOString(new Date(detailErrors[i].hanDangKiem), false)
                    : null) || null
              };

              errors.push(objDetail);
              // đoạn này để kiểm tra khi người sửa mà nhập k đủ dữ liệu serial..
              if (
                (detailErrors[i].details[j].isRequireSP == 1 &&
                  (detailErrors[i].details[j].newSerial?.length == 0 || !detailErrors[i].details[j].newSerial)) ||
                (detailErrors[i].details[j].isRequireSP == 2 &&
                  (detailErrors[i].details[j].newPhone?.length == 0 || !detailErrors[i].details[j].newPhone))
              ) {
                isNotEnoughData = true;
              }
            }
          } else {
            // 3. Không có details → push object trống diagnosis/handling nếu không có errors
            const objDetail = {
              id: +detailErrors[i].id || 0,
              vehicleType: detailErrors[i].vehicleType || '',
              oldMaSanPham: detailErrors[i].oldMaSanPham || '',
              oldSerial: detailErrors[i].oldSerial || '',
              registrationPlate: detailErrors[i].registrationPlate || '',
              errorTpye: detailErrors[i].errorTpye || '',
              phenomenon: detailErrors[i].phenomenon || '',
              note: detailErrors[i].note || '',
              companyId: detailErrors[i].companyId || 0,
              doiXe: detailErrors[i].doiXe || '',
              hanDangKiem:
                ((moment(detailErrors[i].hanDangKiem)?.isValid() || detailErrors[i].hanDangKiem?._isValid) &&
                Number((detailErrors[i].hanDangKiem + '').split('-')[0]) > 2010
                  ? Helpers.ConvertDateToISOString(new Date(detailErrors[i].hanDangKiem), false)
                  : null) || null,
              diagnosis: diagnosisNew || '',
              handling: handlingNew || '',
              newSerial: '',
              newMaSanPham: '',
              cost: 0,
              oldPhone: detailErrors[i].oldPhone || '',
              newPhone: ''
            };

            errors.push(objDetail);
          }
        }

        body['errors'] = errors;

        // kiểm tra có tạo sửa chữa bảo hành không k??
        if (errors.length == 0) {
          message.warning(t('OrganizedSales.OrderManager.CreateOrder.NotDetailOrder'));
          return;
        }

        if (errors.length == 0) {
          message.warning(t('OrganizedSales.OrderManager.CreateOrder.NotDetailOrder'));
          return;
        }

        typeStatus = 'UpdateRepairAfterComplete';
      }

      if (rowSelected?.orderType?.id == 7) {
        body['items'] = [];

        const upgrades: any[] = [];
        // console.log('event.UpgradeItems', event.UpgradeItems, detailUpgrades, JSON.parse(refDetailUpgrades.current));
        const Upgrades = detailUpgrades;

        for (let i = 0; i < Upgrades.length; i++) {
          if (Upgrades[i].details) {
            // có chi tiết mã sản phẩm sẽ gán vô msp mới nhes
            for (let j = 0; j < Upgrades[i].details.length; j++) {
              const findNoteTB = rowSelected.upgradeDetails.find(
                upgradeDetail => upgradeDetail.id == Upgrades[i].details[j].id
              );
              const product = { ...Upgrades[i].details[j] };
              const objDetail = {
                ...product,
                id: Upgrades[i].details[j].id,
                note: findNoteTB?.note || '',
                phone: Upgrades[i].details[j].phone || '',
                serial: Upgrades[i].details[j].serial || '',
                maSanPhamMoi: Upgrades[i].details[j].maSanPham || '',
                vehicleType: Upgrades[i].vehicleType || '',
                registrationPlate: Upgrades[i].registrationPlate || '',
                companyId: Upgrades[i].companyId || 0,
                doiXe: Upgrades[i].doiXe || '',
                hanDangKiem: Upgrades[i].hanDangKiem || null
              };
              if (product['amount']) {
                for (let k = 0; k < product['amount']; k++) {
                  objDetail['id'] = product['ids'][k] || 0;
                  upgrades.push({ ...objDetail });
                }
                continue;
              }
              upgrades.push(objDetail);
            }
          }
          if (Upgrades[i].products) {
            // có chi tiết mã sản phẩm sẽ gán vô msp mới nhes
            for (let j = 0; j < Upgrades[i].products.length; j++) {
              const findNoteTB = rowSelected.upgradeDetails.find(
                upgradeDetail => upgradeDetail.id == Upgrades[i].products[j].id
              );
              const product = { ...Upgrades[i].products[j] };
              const objDetail = {
                ...product,
                id: Upgrades[i].products[j].id,
                note: findNoteTB?.note || '',
                phone: Upgrades[i].products[j].phone || '',
                phoneCu: Upgrades[i].products[j].phoneCu || '',
                serial: Upgrades[i].products[j].serial || '',
                serialCu: Upgrades[i].products[j].serialCu || '',
                maSanPhamMoi: Upgrades[i].products[j].maSanPhamMoi || '',
                vehicleType: Upgrades[i].vehicleType || '',
                registrationPlate: Upgrades[i].registrationPlate || '',
                companyId: Upgrades[i].companyId || 0,
                doiXe: Upgrades[i].doiXe || '',
                hanDangKiem: Upgrades[i].hanDangKiem || null
              };
              upgrades.push(objDetail);
            }
          } else {
            isNotEnoughData = true;
          }
        }

        body['items'] = upgrades.map((upgrade: any) => {
          const originDetail = rowSelected.upgradeDetails.find((d: any) => d.id == upgrade.id);

          return {
            ...upgrade,
            vehicleType: upgrade.vehicleType || '',
            registrationPlate: upgrade.registrationPlate || '',
            maSanPhamMoi: upgrade.maSanPhamMoi || '',
            maSanPhamCu: upgrade.maSanPhamCu || '',
            serialCu: upgrade.serialCu || '',
            phoneCu: upgrade.phoneCu || '',
            companyId: upgrade.companyId || 0,
            doiXe: upgrade.doiXe || '',
            priceAfterVat: useVAT ? upgrade.priceAfterVat || 0 : upgrade.cost || 0,
            vatValue: useVAT ? upgrade.vatValue || 0 : originDetail?.vatValue || 0,
            hanDangKiem:
              ((moment(upgrade.hanDangKiem)?.isValid() || upgrade.hanDangKiem?._isValid) &&
              Number((upgrade.hanDangKiem + '').split('-')[0]) > 2010
                ? Helpers.ConvertDateToISOString(new Date(upgrade.hanDangKiem || '0001-01-01T23:00:00'), false)
                : null) || null
          };
        });
        // body['items'] = upgrades.map((upgrade: any, index: any) => ({
        //   ...upgrade,
        //   vehicleType: upgrade.vehicleType || '',
        //   registrationPlate: upgrade.registrationPlate || '',
        //   maSanPhamMoi: upgrade.maSanPhamMoi || '',
        //   maSanPhamCu: upgrade.maSanPhamCu || '',
        //   serialCu: upgrade.serialCu || '',
        //   phoneCu: upgrade.phoneCu || '',
        //   companyId: upgrade.companyId || 0,
        //   doiXe: upgrade.doiXe || '',
        //   priceAfterVat: useVAT ? upgrade.priceAfterVat || 0 : upgrade.cost || 0,
        //   vatValue: useVAT ? upgrade.vatValue || 0 : rowSelected.upgradeDetails[index].vatValue || 0,
        //   hanDangKiem:
        //     ((moment(upgrade.hanDangKiem)?.isValid() || upgrade.hanDangKiem?._isValid) &&
        //     Number((upgrade.hanDangKiem + '').split('-')[0]) > 2010
        //       ? Helpers.ConvertDateToISOString(new Date(upgrade.hanDangKiem || '0001-01-01T23:00:00'), false)
        //       : null) || null // new Date là bắt buộc và k đặt onlyDate (các date input theo mẫu dùng form đều phải dùng các này),
        // }));

        typeStatus = 'UpdateUpgradeAfterComplete';
      }
      if (rowSelected?.orderType?.id == 8) {
        // console.log('finishOrder Tháo lắp lại', null);

        body['items'] = [];

        const replaces: any = [];
        for (let i = 0; i < detailReplace.length; i++) {
          if (detailReplace[i].products) {
            for (let j = 0; j < detailReplace[i].products.length; j++) {
              const product = { ...detailReplace[i].products[j] };
              const objDetail = {
                oldVehicleType: detailReplace[i]['oldVehicleType'] || '',
                oldRegistrationPlate: detailReplace[i]['oldRegistrationPlate'] || '',
                oldCompanyId: detailReplace[i]['oldCompanyId'] || 0,
                oldDoiXe: detailReplace[i]['oldDoiXe'] || '',
                oldHanDangKiem: detailReplace[i]['oldHanDangKiem'] || null,
                newVehicleType: detailReplace[i]['newVehicleType'] || '',
                newRegistrationPlate: detailReplace[i]['newRegistrationPlate'] || '',
                newCompanyId: detailReplace[i]['newCompanyId'] || 0,
                newDoiXe: detailReplace[i]['newDoiXe'] || '',
                newHanDangKiem: detailReplace[i]['newHanDangKiem'] || null,
                staffExecute: detailReplace[i]['staffExecute'] || '',
                note: detailReplace[i]['note'] || '',
                ...product,
                cost:
                  (product.cost == null || product.cost == undefined || product.cost == '') && product.cost != 0
                    ? product.maSanPham && product.maSanPham != ''
                      ? productMix.find(proMix => proMix.maSanPham == product.maSanPham)?.giaBanSi || 0
                      : 0
                    : product.cost // check thêm cost vào đây
              };
              replaces.push(objDetail);

              if (
                // sp thay thế
                (product.isRequireSP == 1 && (product.serial?.length == 0 || !product.serial)) ||
                (product.isRequireSP == 2 && (product.phone?.length == 0 || !product.phone))
              ) {
                isNotEnoughData = true;
              }
            }
          } else {
            replaces.push({
              ...detailReplace[i]
            });
          }

          if (detailReplace[i].details) {
            for (let j = 0; j < detailReplace[i].details.length; j++) {
              const product = { ...detailReplace[i].details[j] };
              const objDetail = {
                oldVehicleType: detailReplace[i]['oldVehicleType'] || '',
                oldRegistrationPlate: detailReplace[i]['oldRegistrationPlate'] || '',
                oldCompanyId: detailReplace[i]['oldCompanyId'] || 0,
                oldDoiXe: detailReplace[i]['oldDoiXe'] || '',
                oldHanDangKiem: detailReplace[i]['oldHanDangKiem'] || null,
                newVehicleType: detailReplace[i]['newVehicleType'] || '',
                newRegistrationPlate: detailReplace[i]['newRegistrationPlate'] || '',
                newCompanyId: detailReplace[i]['newCompanyId'] || 0,
                newDoiXe: detailReplace[i]['newDoiXe'] || '',
                newHanDangKiem: detailReplace[i]['newHanDangKiem'] || null,
                staffExecute: detailReplace[i]['staffExecute'] || '',
                note: detailReplace[i]['note'] || '',
                ...product,
                cost:
                  (product.cost == null || product.cost == undefined || product.cost == '') && product.cost != 0
                    ? product.maSanPhamMoi && product.maSanPhamMoi != ''
                      ? productMix.find(proMix => proMix.maSanPham == product.maSanPhamMoi)?.giaBanSi || 0
                      : 0
                    : product.cost // check thêm cost vào đây
              };
              replaces.push(objDetail);

              if (
                // sp mới...
                (product.isRequireSPMoi == 1 && (product.serialMoi?.length == 0 || !product.serialMoi)) ||
                (product.isRequireSPMoi == 2 && (product.phoneMoi?.length == 0 || !product.phoneMoi))
              ) {
                isNotEnoughData = true;
              }
            }
          }
        }

        body['items'] = replaces.map((replace: any, index: any) => ({
          ...replace,
          oldVehicleType: replace['oldVehicleType'] || '',
          oldRegistrationPlate: replace['oldRegistrationPlate'] || '',
          oldCompanyId: replace['oldCompanyId'] || 0,
          oldDoiXe: replace['oldDoiXe'] || '',
          newVehicleType: replace['newVehicleType'] || '',
          newRegistrationPlate: replace['newRegistrationPlate'] || '',
          newCompanyId: replace['newCompanyId'] || 0,
          newDoiXe: replace['newDoiXe'] || '',
          note: replace['note'] || '',
          serial: replace['serial'] || '',
          phone: replace['phone'] || '',
          maSanPham: replace['maSanPham'] || '',
          serialMoi: replace['serialMoi'] || '',
          phoneMoi: replace['phoneMoi'] || '',
          maSanPhamMoi: replace['maSanPhamMoi'] || '',
          priceAfterVat: useVAT ? replace['priceAfterVat'] || 0 : rowSelected.orderDetails[index]?.priceAfterVat || 0,
          vatValue: useVAT ? replace['vatValue'] || 0 : rowSelected.orderDetails[index]?.vatValue || 0,
          cost: replace['cost'] || 0,
          oldHanDangKiem:
            ((moment(replace.oldHanDangKiem)?.isValid() || replace.oldHanDangKiem?._isValid) &&
            Number((replace.oldHanDangKiem + '').split('-')[0]) > 2010
              ? Helpers.ConvertDateToISOString(new Date(replace.oldHanDangKiem || '0001-01-01T23:00:00'))
              : null) || null,
          newHanDangKiem:
            ((moment(replace.newHanDangKiem)?.isValid() || replace.newHanDangKiem?._isValid) &&
            Number((replace.newHanDangKiem + '').split('-')[0]) > 2010
              ? Helpers.ConvertDateToISOString(new Date(replace.newHanDangKiem || '0001-01-01T23:00:00'))
              : null) || null
        }));

        // có thêm bước check thiếu serial hoặc sđt thì k cho pass !!!

        typeStatus = 'UpdateOrderThaoLapLaiAfterComplete';
      }

      if (rowSelected?.orderType?.id == 11) {
        // có thêm bước check thiếu serial hoặc sđt thì k cho pass !!!

        const sum = (Object.values(formData) as number[]).reduce((acc, curr) => acc + curr, 0);

        body['tienThanhToan'] = tienThanhToanNew > 0 ? tienThanhToanNew : payWillMoney || 0;
        body['tienDaThu'] = sum || 0;

        typeStatus = 'UpdateDebtOrderAfterComplete';
      }

      if (rowSelected?.orderType?.id === 13) {
        const flatDiff = detailChenhLechs.flatMap((item: any) => item.diff || []);

        body['maDonHang'] = rowSelected.maDonHang || '';
        body['customerName'] = cusName || rowSelected.customerInfo?.customerName || '';
        body['customerPhone'] = SĐT || rowSelected.customerInfo?.customerPhone || '';
        body['orderAddress'] = {
          lng: rowSelected.customerInfo?.orderAddress?.lng || 0,
          lat: rowSelected.customerInfo?.orderAddress?.lat || 0,
          address: AddressShip || rowSelected.customerInfo?.orderAddress?.address || ''
        };

        // Map lại mảng diff để đảm bảo đúng định dạng số và chuỗi
        body['diff'] = flatDiff.map((item: any) => ({
          soHoaDon: item.soHoaDon || '',
          thuChenhLech: Number(item.thuChenhLech) || 0
        }));

        body['updateNote'] = note || ''; // Hoặc field ghi chú bạn đang dùng
        body['sdtLienHe'] = ContactSĐT || rowSelected.customerInfo?.sdtLienHe || '';
        body['tenNguoiLienHe'] = ContactCusName || rowSelected.customerInfo?.tenNguoiLienHe || '';
        body['companyName'] = CompanyDevice || rowSelected.companyName || 'AnhDuong';

        // Đảm bảo listKinhDoanh là mảng string
        body['listKinhDoanh'] = detailChenhLechs.flatMap((detail: any) => detail.listKinhDoanh || []);

        typeStatus = 'UpdateDiffOrder';
        // Tiếp tục xử lý gọi API với object body này...
      }

      if (isNotEnoughData) {
        console.log('dừng gọi api vì data k hợp lệ');
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.DataNotValid'), 'error');
        return;
      }

      typeStatus && handleActionStaff(typeStatus, body, 'EditComplete');
    },
    // nv sale hoặc kd
    reOrder: (e?: any) => {
      // chưa dùng đến
      console.log('reOrder', e);
    },

    pendingOrder: (note?: any) => {
      const body = {
        maDonHang: rowSelected.maDonHang,
        thoiGianHen: timePostPone && Helpers.ConvertDateToISOString(new Date(timePostPone)),
        note: note || ''
      };
      // check lại coi là
      if (timePostPone == null) {
        // set form date hẹn lắp
        const errorFeilds = [
          {
            name: 'DateDeliver',
            errors: [t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.ChangeTimeDeliverRequire')]
          }
        ];
        setErrorFields && setErrorFields(errorFeilds);
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.TimePostPoneRequire'), 'error');
        return;
      }
      if (note.length == 0) {
        const errorFeilds = [
          {
            name: 'noticeText',
            errors: [t('Input.FieldError.RequireText')]
          }
        ];
        setErrorFields && setErrorFields(errorFeilds);
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.NoteRequire'), 'error');
        return;
      }
      setErrorFields &&
        setErrorFields([
          {
            name: 'noticeText',
            errors: []
          }
        ]);
      handleActionStaff('Pending', body, 'Pended');
    },
    cancelOrder: (note?: string, role?: string) => {
      const body = {
        maDonHang: rowSelected.maDonHang,
        reason: note + ' | ' + role || ''
      };

      if (note.length == 0) {
        const errorFeilds = [
          {
            name: 'noticeText',
            errors: [t('Input.FieldError.RequireText')]
          }
        ];
        setErrorFields && setErrorFields(errorFeilds);
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.NoteRequire'), 'error');
        return;
      }

      setErrorFields &&
        setErrorFields([
          {
            name: 'noticeText',
            errors: []
          }
        ]);
      handleActionStaff('Cancel', body, 'Canceled');
    },
    cancelOrderThuNo: (note?: string, role?: string) => {
      const body = {
        maDonHang: rowSelected.maDonHang,
        reason: note + ' | ' + role || ''
      };

      if (note.length == 0) {
        const errorFeilds = [
          {
            name: 'noticeText',
            errors: [t('Input.FieldError.RequireText')]
          }
        ];
        setErrorFields && setErrorFields(errorFeilds);
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.NoteRequire'), 'error');
        return;
      }

      setErrorFields &&
        setErrorFields([
          {
            name: 'noticeText',
            errors: []
          }
        ]);
      handleActionStaff('CancelDebtOrder', body, 'Canceled');
    },
    sendFeedBack: (note?: string) => {
      const body = {
        maDonHang: rowSelected.maDonHang,
        note: note || '',
        isCalled: true
      };
      handleActionStaff('CSCallToCustomer', body, 'SentFeedBack');
    },
    // nv kỹ thuật
    rejectOrder: (note?: string) => {
      if (note.length == 0) {
        checkFormDetail && checkFormDetail();
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.NoteRequire'), 'error');
        return;
      }

      const body = {
        maDonHang: rowSelected.maDonHang,
        reason: note || '',
        note: ''
      };
      handleActionStaff('Reject', body, 'Rejected');
    },
    // getOrder: (note?: string) => {
    //   // nhận đơn
    //   const body = {
    //     maDonHang: rowSelected.maDonHang,
    //     note: note || ''
    //   };
    //   handleActionStaff('Accept', body, 'Accepted');
    // },
    getOrder: (note?: string) => {
      // nhận đơn
      const body = {
        maDonHang: rowSelected.maDonHang,
        note: note || ''
      };
      handleActionStaff('AcceptV2', body, 'Accepted');
    },
    // workingOrder: (note?: string) => {
    //   const body = {
    //     maDonHang: rowSelected.maDonHang,
    //     startTime: Helpers.ConvertDateToISOString(new Date()),
    //     note: note || ''
    //   };
    //   handleActionStaff('Start', body, 'Started');
    // },
    workingOrder: (note?: string) => {
      const body = {
        maDonHang: rowSelected.maDonHang,
        startTime: Helpers.ConvertDateToISOString(new Date()),
        note: note || ''
      };
      handleActionStaff('StartV2', body, 'Started');
    },
    pauseOrder: async (lyDo?: string, maDonHang?: any, type?: any) => {
      const body = {
        maDonHang: maDonHang || rowSelected.maDonHang,
        lyDo: lyDo || ''
      };
      let typeStatus = null;
      if (lyDo.length == 0) {
        const errorFeilds = [
          {
            name: 'noticeText',
            errors: [t('Input.FieldError.RequireText')]
          }
        ];
        setErrorFields && setErrorFields(errorFeilds);
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.NoteRequire'), 'error');
        return;
      }

      // if (type === 'pauseRequest') {
      //   typeStatus = 'PauseRequest';
      // }
      if (type === 'pauseRequest') {
        typeStatus = 'PauseRequestV2';
      }
      typeStatus && handleActionStaff(typeStatus, body, 'Finished', rowSelected.maDonHang, type);
    },
    resumeOrder: async (maDonHang?: any) => {
      try {
        dispatch(updatePageLoadingApi(true));
        await OrderManagerApi.ActionStatusOrder('ResumeV2', maDonHang).then(res => {
          // await OrderManagerApi.ActionStatusOrder('Resume', maDonHang).then(res => {
          console.log('res', res, !res.data.error);
          if (!res.data.error) {
            showMessage(t(`OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Success.Resume`), 'success');
            // dispatch(updateReqReGetOrder(true)); // chỉ update đơn đang thao tác !!
            setTimeout(() => {
              dispatch(getDetailOfOrder({ maDonHang: maDonHang, typeOrder: rowSelected.orderType.id })); // gọi lên lấy data mới luôn !!
            }, 250);
          } else {
            // SubMsg
            showMessage(
              t(`OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Error.Resume`) + '. Err! ' + res.data.message ||
                '',
              'error'
            );
          }
          setTimeout(() => {
            dispatch(updatePageLoadingApi(false));
          }, 250);
        });
      } catch (error) {
        console.log(error);
        dispatch(updatePageLoadingApi(false));
        showMessage(t(`OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Error.Resume`), 'error');
      }
    },
    // approvePauseOrder: async (maDonHang?: any, type?: any) => {
    //   const data = {
    //     maDonHang,
    //     isApproved: type
    //   };
    //   try {
    //     dispatch(updatePageLoadingApi(true));
    //     await OrderManagerApi.ActionStatusOrder('ApprovePauseRequest', data).then(res => {
    //       console.log('res', res, !res.data.error);
    //       if (!res.data.error) {
    //         showMessage(
    //           t(`OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Success.ApprovePauseRequest`),
    //           'success'
    //         );
    //         // dispatch(updateReqReGetOrder(true)); // chỉ update đơn đang thao tác !!
    //         setTimeout(() => {
    //           dispatch(getDetailOfOrder({ maDonHang: data.maDonHang, typeOrder: rowSelected.orderType.id })); // gọi lên lấy data mới luôn !!
    //         }, 250);
    //       } else {
    //         // SubMsg
    //         showMessage(
    //           t(`OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Error.ApprovePauseRequest`) +
    //             '. Err! ' +
    //             res.data.message || '',
    //           'error'
    //         );
    //       }
    //       setTimeout(() => {
    //         dispatch(updatePageLoadingApi(false));
    //       }, 250);
    //     });
    //   } catch (error) {
    //     console.log(error);
    //     dispatch(updatePageLoadingApi(false));
    //     showMessage(t(`OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Error.ApprovePauseRequest`), 'error');
    //   }
    //   // typeStatus && handleActionStaff(typeStatus, body, 'Finished', rowSelected.maDonHang, type);
    // },

    approvePauseOrder: async (maDonHang?: any, isApprove?: boolean, staff?: string) => {
      const data = { maDonHang, staff, isApprove }; //  key là isApprove

      try {
        dispatch(updatePageLoadingApi(true));
        const res = await OrderManagerApi.ActionStatusOrder('ApprovePauseRequestV2', data);
        if (!res.data.error) {
          showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Success.ApprovePauseRequest'), 'success');
          setTimeout(() => {
            dispatch(getDetailOfOrder({ maDonHang, typeOrder: rowSelected.orderType.id }));
          }, 250);
        } else {
          showMessage(res.data.message, 'error');
        }
      } catch (e) {
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Error.ApprovePauseRequest'), 'error');
      } finally {
        setTimeout(() => dispatch(updatePageLoadingApi(false)), 250);
      }
    },

    approveAllPauseOrder: async (maDonHang?: any, isApproved?: boolean) => {
      //  API này dùng query string: ?maDonHang=...&isApproved=...
      try {
        dispatch(updatePageLoadingApi(true));
        const res = await OrderManagerApi.ActionStatusOrder('ApproveAllPauseRequestV2', { maDonHang, isApproved });
        if (!res.data.error) {
          showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Success.ApprovePauseRequest'), 'success');
          setTimeout(() => {
            dispatch(getDetailOfOrder({ maDonHang, typeOrder: rowSelected.orderType.id }));
          }, 250);
        } else {
          showMessage(res.data.message, 'error');
        }
      } catch (e) {
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.Error.ApprovePauseRequest'), 'error');
      } finally {
        setTimeout(() => dispatch(updatePageLoadingApi(false)), 250);
      }
    },

    finishOrder: async (note?: string, maDonHang?: any, type?: any) => {
      const hasValue = (v: any) => v !== undefined && v !== null && v !== '';

      const resolveNumber = (...candidates: any[]): number => {
        for (const c of candidates) {
          if (hasValue(c)) return Number(c);
        }
        return 0;
      };

      // Giữ giá trị nếu cờ chưa xác định hoặc đúng loại cần (1 = serial, 2 = phone); ngược lại xóa
      const keepByRequire = (flag: any, type: 1 | 2, value: any) =>
        flag === undefined || flag === null || Number(flag) === type ? value || '' : '';

      // trong đây các đoạn xử lý bị loop với chỗ khác, rảnh thì gom lại cho dễ sửa về sau
      let isNotEnoughData = false;
      let isNotEnoughBienSo = false;
      const unconfirmedProducts: string[] = []; // đơn nâng cấp: SP KT đổi/thêm chưa có summary của bên tạo đơn
      const body = {
        maDonHang: rowSelected.maDonHang,
        finishTime: Helpers.ConvertDateToISOString(new Date()),
        note: note || ''
      };
      let typeStatus = null;
      if (
        rowSelected?.orderType?.id == 1 ||
        rowSelected?.orderType?.id == 2 ||
        rowSelected?.orderType?.id == 6 ||
        rowSelected?.orderType?.id == 10
      ) {
        const detailBase = methods.getValues('BaseItems'); // lấy trực tiếp struct daat  từ store
        const isValid = await methods.trigger();
        if (!isValid) {
          const allErrors: any = methods.control._formState.errors.BaseItems;

          if (allErrors) {
            const firstErrorIndex = allErrors.findIndex(error => error !== undefined);
            if (firstErrorIndex !== -1) {
              console.log('Ô lỗi đầu tiên nằm ở xe thứ mấy:', firstErrorIndex);

              const errorRow = allErrors[firstErrorIndex];
              let detailIdx = 0;
              let subFieldName = '';

              // check nếu lỗi đầu tiên có chi tiết errorRow.details
              if (errorRow.details) {
                // dò tiếp coi phần tử nào đầu tiên bị lỗi
                detailIdx = errorRow.details.findIndex(d => d != null);
                if (detailIdx !== -1) {
                  const subDetailError = errorRow.details[detailIdx];
                  subFieldName = Object.keys(subDetailError)[0];
                  // firstFieldName = `details[${detailIdx}].${subFieldName}`;
                  // firstErrorMessage = subFieldName
                }
              } else {
                // nếu k dò đc details, là lỗi này ngay tại thông tin thiết bị, dòng đó luôn
                subFieldName = Object.keys(errorRow)[0];
              }

              // console.log(
              //   'Thông tin lỗi dòng nào, thứ mấy details, field name:',
              //   firstErrorIndex,
              //   detailIdx,
              //   subFieldName
              // );
              setInputError({
                gIdx: firstErrorIndex,
                dIdx: detailIdx,
                fieldName: subFieldName
              });

              //  virtuosoRef.current.scrollToIndex({
              //   index: firstErrorIdx,
              //   align: 'center',
              //   behavior: 'smooth'
              // });
            }
          }
          return;
        }
        // setInputError(null)
        // console.log('finishOrder base', detailBase); // cần map lại data vì có những trường k có
        const bases: any = [];
        for (let i = 0; i < detailBase.length; i++) {
          if (detailBase[i].details) {
            for (let j = 0; j < detailBase[i].details.length; j++) {
              const product = { ...detailBase[i].details[j] };
              const objDetail = {
                vehicleType: detailBase[i].vehicleType || '',
                registrationPlate: detailBase[i].registrationPlate || '',
                companyId: detailBase[i].companyId || 0,
                doiXe: detailBase[i].doiXe || '',
                hanDangKiem: detailBase[i].hanDangKiem || null,
                staffExecute: detailBase[i].staffExecute || '',
                ...product
              };
              if (product['amount']) {
                for (let k = 0; k < product['amount']; k++) {
                  bases.push(objDetail);
                }
                continue;
              }

              bases.push(objDetail);
            }
          } else {
            bases.push({
              ...detailBase[i]
            });
          }
        }

        body['items'] = bases
          .filter(errF => !errF.staffExecute || errF.staffExecute == uLogin.username)
          .map(base => {
            if ([2, 6, 10].includes(rowSelected?.orderType?.id)) {
              if (!base.registrationPlate || base.registrationPlate.trim() === '') {
                isNotEnoughBienSo = true;
              }
            }

            return {
              ...base,
              id: typeof base.id === 'string' ? 0 : base.id || 0, // string là key để form quản lý, gửi thì gửi cái cũ server là số, còn string thì đổi về 0
              vehicleType: base.vehicleType || '',
              registrationPlate: base.registrationPlate || '',
              maSanPham: base.maSanPham || '',
              serial: base.serial || '',
              phone: base.phone || '',
              companyId: base.companyId || '',
              doiXe: base.doiXe || '',
              hanDangKiem:
                ((moment(base.hanDangKiem)?.isValid() || base.hanDangKiem?._isValid) &&
                Number((base.hanDangKiem + '').split('-')[0]) > 2010
                  ? Helpers.ConvertDateToISOString(new Date(base.hanDangKiem || '0001-01-01T23:00:00'), false)
                  : null) || null // new Date là bắt buộc và k đặt onlyDate (các date input theo mẫu dùng form đều phải dùng các này),
            };
          });

        typeStatus = 'Finish';
      }

      // ============================================================================
      // ĐƠN 4 / 5: SỬA CHỮA - BẢO HÀNH
      // ============================================================================
      if (rowSelected?.orderType?.id == 4 || rowSelected?.orderType?.id == 5) {
        const productMix = [...productCategoryPMP, ...productCategoryPMS];

        // dữ liệu gốc từ rowSelected để fallback khi form thiếu field
        const rawRepairItems: any[] = rowSelected?.itemsRepair || rowSelected?.errorList || [];
        const findRawParent = (id: any) => rawRepairItems.find(r => r.id === id);
        const findRawChild = (parent: any, id: any) => parent?.details?.find((d: any) => d.id === id);

        // --------------------------------------------------------------------------
        // Helpers
        // --------------------------------------------------------------------------
        const stripSemicolon = (s: any) => (typeof s === 'string' ? s.replaceAll(';', '').trim() : '');

        const normalizeHanDangKiem = (value: any) => {
          const isValidDate = moment(value)?.isValid() || value?._isValid;
          const validYear = Number((value + '').split('-')[0]) > 2010;
          return isValidDate && validYear ? Helpers.ConvertDateToISOString(new Date(value), false) : null;
        };

        // Gom errors[] của 1 dòng thành chuỗi diagnosis/handling ngăn cách bằng ';'
        // (diagnosis lặp lại theo số handling để 2 chuỗi luôn khớp vị trí)
        const buildDiagnosisHandling = (parent: any, rawParent: any) => {
          if (parent.errors?.length > 0) {
            const diagnoses: string[] = [];
            const handlings: string[] = [];

            for (const errorItem of parent.errors) {
              const diagnosis = errorItem.newDiagnosis?.replaceAll(';', '') || '';
              const rawHandling = errorItem.newHandling;
              const handlingList: any[] | null = Array.isArray(rawHandling)
                ? rawHandling
                : typeof rawHandling === 'string'
                ? [rawHandling]
                : null;
              const cleaned = (handlingList || []).map(stripSemicolon).filter(Boolean);

              if (cleaned.length > 0) {
                handlings.push(...cleaned);
                diagnoses.push(...Array(cleaned.length).fill(diagnosis));
              } else if (handlingList || diagnosis) {
                diagnoses.push(diagnosis);
                handlings.push('');
              }
            }
            return { diagnosis: diagnoses.join(';'), handling: handlings.join(';') };
          }

          // fallback: form không có errors mới -> lấy diagnosis/handling gốc
          if (rawParent?.diagnosis || rawParent?.handling) {
            return { diagnosis: rawParent.diagnosis || '', handling: rawParent.handling || '' };
          }
          return { diagnosis: '', handling: '' };
        };

        // Các field thông tin xe/thiết bị dùng chung cho dòng có details và không có details
        const buildParentFields = (parent: any, rawParent: any) => ({
          errorTpye: parent.errorTpye || rawParent?.errorTpye || '',
          oldMaSanPham: parent.oldMaSanPham || rawParent?.oldMaSanPham || '',
          oldSerial: parent.oldSerial || rawParent?.oldSerial || '',
          oldPhone: parent.oldPhone || rawParent?.oldPhone || '',
          phenomenon: parent.phenomenon || rawParent?.phenomenon || '',
          vehicleType: parent.vehicleType || rawParent?.vehicleType || '',
          registrationPlate: parent.registrationPlate || rawParent?.registrationPlate || '',
          companyId: parent.companyId || rawParent?.companyId || 0,
          doiXe: parent.doiXe || rawParent?.doiXe || '',
          hanDangKiem: normalizeHanDangKiem(parent.hanDangKiem) || rawParent?.hanDangKiem || null
        });

        // Dòng có details: mỗi detail là 1 sản phẩm mới
        const buildDetailItem = (
          parent: any,
          rawParent: any,
          product: any,
          j: number,
          diagHandling: { diagnosis: string; handling: string }
        ) => {
          const rawChild = findRawChild(rawParent, product.id) || rawParent?.details?.[j];

          const newMaSanPham = product.newMaSanPham || rawChild?.newMaSanPham || '';
          // Chỉ dùng serial/phone đã lưu khi vẫn đúng sản phẩm đó (đổi sang SP khác thì dữ liệu cũ không còn hiệu lực)
          const savedChild = rawChild && rawChild.newMaSanPham === newMaSanPham ? rawChild : undefined;

          // Cờ isRequireSP của thẻ quyết định giữ/xóa: không cần -> gửi '' để ghi đè dữ liệu cũ
          const newSerial = keepByRequire(product.isRequireSP, 1, product.newSerial || savedChild?.newSerial);
          const newPhone = keepByRequire(product.isRequireSP, 2, product.newPhone || savedChild?.newPhone);

          return {
            ...product,
            ...buildParentFields(parent, rawParent),
            id: j === 0 ? +parent.id || 0 : product.id || 0,
            note: product.note || rawChild?.note || '',
            diagnosis: diagHandling.diagnosis,
            handling: diagHandling.handling,
            newMaSanPham,
            newSerial,
            newPhone,
            cost: resolveNumber(rawChild?.cost || 0),
            priceAfterVat: resolveNumber(
              useVAT
                ? rawChild?.priceAfterVat || rawParent?.priceAfterVat || 0
                : rawChild?.cost ||
                    (product.newMaSanPham
                      ? productMix.find(p => p.maSanPham === product.newMaSanPham)?.giaBanSi || 0
                      : 0) ||
                    0
            ),
            vatValue: resolveNumber(useVAT ? product.vatValue || rawChild?.vatValue || rawParent?.vatValue || 0 : 0)
          };
        };

        // Dòng không có details: chỉ mang thông tin lỗi + dữ liệu gốc
        const buildParentOnlyItem = (
          parent: any,
          rawParent: any,
          diagHandling: { diagnosis: string; handling: string }
        ) => ({
          ...buildParentFields(parent, rawParent),
          id: +parent.id || 0,
          note: parent.note || rawParent?.note || '',
          diagnosis: diagHandling.diagnosis,
          handling: diagHandling.handling,
          newMaSanPham: rawParent?.newMaSanPham || '',
          newSerial: rawParent?.newSerial || '',
          newPhone: rawParent?.newPhone || '',
          cost: resolveNumber(rawParent?.cost || 0),
          priceAfterVat: resolveNumber(useVAT ? rawParent?.priceAfterVat || 0 : 0),
          vatValue: resolveNumber(useVAT ? rawParent?.vatValue || 0 : 0)
        });

        // Thiếu serial/phone theo ĐÚNG giá trị sẽ gửi lên (đã qua keepByRequire)
        const isMissingRequiredData = (item: any) =>
          (item.isRequireSP == 1 && !item.newSerial) || (item.isRequireSP == 2 && !item.newPhone);

        // --------------------------------------------------------------------------
        // Build repairInfo
        // --------------------------------------------------------------------------
        const repairItems: any[] = [];

        for (const parent of detailErrors || []) {
          const rawParent = findRawParent(parent.id);
          const diagHandling = buildDiagnosisHandling(parent, rawParent);

          if (parent.details?.length > 0) {
            parent.details.forEach((detail: any, j: number) => {
              const item = buildDetailItem(parent, rawParent, { ...detail }, j, diagHandling);
              repairItems.push(item);
              if (isMissingRequiredData(item)) {
                isNotEnoughData = true;
              }
            });
          } else {
            repairItems.push(buildParentOnlyItem(parent, rawParent, diagHandling));
          }
        }

        body['repairInfo'] = repairItems;

        // typeStatus = 'FinishRepair';
        typeStatus = 'FinishRepairV2';

        // Kiểm tra đủ thông tin: SP yêu cầu serial/phone (Hàng hoá) thì newSerial/newPhone không được trống
      }

      if (rowSelected?.orderType?.id == 3) {
        body['items'] = [];

        // map nhanh dữ liệu gốc từ rowSelected để tra cứu fallback theo id
        const rawPayFees = rowSelected?.payFees || [];
        const findRawParent = id => rawPayFees.find(p => p.id === id);
        const findRawChild = (parent, id) => parent?.details?.find(d => d.id === id);

        // NGUỒN ĐẦY ĐỦ: details con trong payFees không có vatValue/priceAfterVat,
        // phải tra thêm ở collectingFeeInfo.detail (hoặc DeviceList) theo id
        const rawFullDetails = rowSelected?.collectingFeeInfo?.detail || rowSelected?.DeviceList || [];
        const findFullDetail = id => rawFullDetails.find(d => d.id === id);

        const payfees: any[] = [];
        const PayFees = detailPayFees;

        for (let i = 0; i < PayFees.length; i++) {
          const error = { ...detailPayFees[i] };
          const rawParent = findRawParent(PayFees[i].id);
          const rawParentFull = findFullDetail(PayFees[i].id); // fallback thêm cho parent nếu cần

          const parentObj = {
            ...error,
            companyId: PayFees[i].companyId || rawParent?.companyId || rawParentFull?.companyId || '',
            isCamera: PayFees[i].isCamera ?? rawParent?.isCamera ?? rawParentFull?.isCamera ?? false,
            servicePackName:
              PayFees[i].servicePackName || rawParent?.servicePackName || rawParentFull?.servicePackName || '',
            cameraCount: PayFees[i].cameraCount || rawParent?.cameraCount || rawParentFull?.cameraCount || 0,
            doiXe: PayFees[i].doiXe || rawParent?.doiXe || rawParentFull?.doiXe || '',
            cost: resolveNumber(rawParent?.cost || rawParentFull?.cost || 0),
            vatValue: resolveNumber(rawParent?.vatValue || rawParentFull?.vatValue || 0),
            priceAfterVat: resolveNumber(rawParent?.priceAfterVat || rawParentFull?.priceAfterVat || 0),
            phone: PayFees[i].phone || rawParent?.phone || rawParentFull?.phone || '',
            staffExecute: PayFees[i].staffExecute || rawParent?.staffExecute || '',
            hanDangKiem: PayFees[i].hanDangKiem || rawParent?.hanDangKiem || rawParentFull?.hanDangKiem || null
          };

          payfees.push(parentObj);

          if (PayFees[i].details) {
            for (let j = 0; j < PayFees[i].details.length; j++) {
              const details = { ...PayFees[i].details[j] };
              const rawChild = findRawChild(rawParent, details.id);
              const rawChildFull = findFullDetail(details.id); // ⭐ nguồn có vatValue/priceAfterVat thật

              const objDetails = {
                ...details,
                id: PayFees[i].details[j].id,
                serial:
                  (PayFees[i].details[j].isRequireSP === 1 && PayFees[i].details[j].serial) ||
                  rawChild?.serial ||
                  rawChildFull?.serial ||
                  '',
                phone:
                  (PayFees[i].details[j].isRequireSP === 2 && PayFees[i].details[j].phone) ||
                  rawChild?.phone ||
                  rawChildFull?.phone ||
                  '',
                bs: PayFees[i].bs || rawParent?.bs || rawChildFull?.bs || '',
                maSanPham: PayFees[i].details[j].maSanPham || rawChild?.maSanPham || rawChildFull?.maSanPham || '',
                companyId: PayFees[i].companyId || rawParent?.companyId || rawChildFull?.companyId || '',
                isCamera: PayFees[i].isCamera ?? rawParent?.isCamera ?? rawChildFull?.isCamera ?? false,
                servicePackName:
                  PayFees[i].servicePackName || rawParent?.servicePackName || rawChildFull?.servicePackName || '',
                cameraCount: PayFees[i].cameraCount || rawParent?.cameraCount || rawChildFull?.cameraCount || 0,
                cost: resolveNumber(rawChild?.cost || rawChildFull?.cost || 0),
                doiXe: PayFees[i].doiXe || rawParent?.doiXe || rawChildFull?.doiXe || '',
                priceAfterVat: resolveNumber(
                  useVAT
                    ? rawChild?.priceAfterVat || rawChildFull?.priceAfterVat || 0
                    : rawChild?.cost || rawChildFull?.cost || 0
                ),
                vatValue: resolveNumber(useVAT ? rawChild?.vatValue || rawChildFull?.vatValue || 0 : 0),
                hanDangKiem:
                  ((moment(PayFees[i].hanDangKiem)?.isValid() || PayFees[i].hanDangKiem?._isValid) &&
                  Number((PayFees[i].hanDangKiem + '').split('-')[0]) > 2010
                    ? Helpers.ConvertDateToISOString(new Date(PayFees[i].hanDangKiem || '0001-01-01T23:00:00'), false)
                    : null) ||
                  rawParent?.hanDangKiem ||
                  rawChildFull?.hanDangKiem ||
                  null,
                type: 1
              };
              if (details['amount']) {
                for (let k = 0; k < details['amount']; k++) {
                  objDetails['id'] = details['ids'][k] || 0;

                  payfees.push({ ...objDetails });
                }
                continue;
              }
              payfees.push(objDetails);

              if (
                (detailPayFees[i].details[j].isRequireSP == 1 &&
                  (detailPayFees[i].details[j].serial?.length == 0 || !detailPayFees[i].details[j].serial)) ||
                (detailPayFees[i].details[j].isRequireSP == 2 &&
                  (detailPayFees[i].details[j].phone?.length == 0 || !detailPayFees[i].details[j].phone))
              ) {
                isNotEnoughData = true;
              }
            }
            if (
              (detailPayFees[i].isRequireSP == 1 &&
                (detailPayFees[i].serial?.length == 0 || !detailPayFees[i].serial)) ||
              (detailPayFees[i].isRequireSP == 2 && (detailPayFees[i].phone?.length == 0 || !detailPayFees[i].phone))
            ) {
              isNotEnoughData = true;
            }
          }
        }
        body['items'] = payfees.map(base => ({
          ...base,
          id: base.id || 0,
          priceAfterVat: useVAT ? base.priceAfterVat || 0 : base.cost || 0,
          vatValue: useVAT ? base.vatValue || 0 : 0,
          hanDangKiem:
            ((moment(base.hanDangKiem)?.isValid() || base.hanDangKiem?._isValid) &&
            Number((base.hanDangKiem + '').split('-')[0]) > 2010
              ? Helpers.ConvertDateToISOString(new Date(base.hanDangKiem || '0001-01-01T23:00:00'), false)
              : null) || null // new Date là bắt buộc và k đặt onlyDate (các date input theo mẫu dùng form đều phải dùng các này),
        }));
        typeStatus = 'FinishCollectFee';
      }

      if (rowSelected?.orderType?.id == 7) {
        // ==========================================================================
        // 0. CONTEXT & HELPERS
        // ==========================================================================
        const hasMultipleTechs = (rowSelected?.executeInfo?.length || 0) >= 2;
        const rawUpgradeDetails: any[] = rowSelected?.upgradeDetails || [];
        const originalSummaries: any[] = rowSelected?.upgradeSummaries || [];

        const findRawDetail = (id: any) => rawUpgradeDetails.find(d => d.id == id);
        const findSummaryById = (id: any) => originalSummaries.find(s => s.id === id);

        // cost/priceAfterVat/vatValue: ưu tiên 1) rawDetail  2) summary  3) 0
        // Dùng ?? để cost = 0 (khuyến mãi/miễn phí) là giá trị hợp lệ
        const resolveCostFields = (rawDetail: any, summary: any) => ({
          cost: resolveNumber(rawDetail?.cost ?? summary?.cost ?? 0),
          priceAfterVat: resolveNumber(
            useVAT ? rawDetail?.priceAfterVat ?? summary?.priceAfterVat ?? 0 : rawDetail?.cost ?? summary?.cost ?? 0
          ),
          vatValue: resolveNumber(useVAT ? rawDetail?.vatValue ?? summary?.vatValue ?? 0 : 0)
        });

        // --- Cấp phát summary theo SỨC CHỨA, không phải 1 summary - 1 detail ---
        // Một summary hợp lệ cho nhiều detail: hàng bộ (main + ruột cùng summaryId) và summary quantity > 1.
        // Sức chứa tính theo cặp (summary, mã SP): mỗi mã SP được dùng tối đa `quantity` lần trên 1 summary.
        // Nếu ép 1-1 thì ruột/thẻ thứ 2 trở đi sẽ sinh summary tạm -> double summaries cho người tạo đơn.
        const usage = new Map<string, number>();
        const usageKey = (id: any, maSP: string) => `${id}|${maSP}`;
        const markUsed = (id: any, maSP: string) =>
          usage.set(usageKey(id, maSP), (usage.get(usageKey(id, maSP)) || 0) + 1);
        const hasRoom = (summary: any, maSP: string) =>
          (usage.get(usageKey(summary.id, maSP)) || 0) < Math.max(1, Number(summary.quantity) || 1);

        // Fallback cho dòng chưa gắn summary (logic chọn nằm ở hook/pickUpgradeSummary.ts).
        // Không gắn vào summary bất kỳ: SP KT thêm phải ra summaryId = 0 để bước 4 hỏi gửi yêu cầu cập nhật.
        const canHold = (summary: any, maSP: string) =>
          summary.maSanPhamMoi === maSP ||
          !!getSetInfo(productSetDataHaveDetails, summary.maSanPhamMoi)?.partCodes.includes(maSP);

        const pickFallbackSummaryId = (hintId: any, registrationPlate: string, companyId: number, maSP: string) => {
          const picked = pickUpgradeSummary({
            summaries: originalSummaries,
            hintId,
            registrationPlate,
            companyId,
            maSP,
            canHold,
            hasRoom
          });
          if (!picked) return 0; // SP KT thêm -> bước 4 hỏi gửi yêu cầu cập nhật
          markUsed(picked.id, maSP);
          return picked.id;
        };

        // Object nền dùng chung cho cả DETAILS và PRODUCTS
        const buildBaseItem = (group: any, product: any, rawDetail: any, maSanPhamMoi: string) => ({
          ...product,
          note: rawDetail?.note || '',
          phone: product.phone || rawDetail?.phone || '',
          phoneCu: product.phoneCu || rawDetail?.phoneCu || '',
          serial: product.serial || rawDetail?.serial || '',
          serialCu: product.serialCu || rawDetail?.serialCu || '',
          maSanPhamMoi,
          vehicleType: group.vehicleType || rawDetail?.vehicleType || '',
          registrationPlate: group.registrationPlate || rawDetail?.registrationPlate || '',
          companyId: group.companyId || rawDetail?.companyId || 0,
          doiXe: group.doiXe || rawDetail?.doiXe || '',
          hanDangKiem: group.hanDangKiem || rawDetail?.hanDangKiem || null
        });

        // Dòng tạm trước khi cấp summary: _preferredId (đã gắn chắc chắn), _hintId (chỉ gợi ý), _costSource (lấy giá)
        const toPending = (base: any, preferredId: any, hintId: any, costSource: any, extra: any = {}) => ({
          ...base,
          ...extra,
          _preferredId: preferredId || 0,
          _hintId: hintId || 0,
          _costSource: costSource
        });

        // ==========================================================================
        // 1 + 2. GOM DETAILS & PRODUCTS THÀNH DANH SÁCH PHẲNG
        // ==========================================================================
        const collectFromDetails = (group: any): any[] =>
          (group.details || []).flatMap((product: any) => {
            const { amount, ids, ...restProduct } = product;
            const rawDetail = findRawDetail(product.id);
            const base = buildBaseItem(
              group,
              restProduct,
              rawDetail,
              product.maSanPham || rawDetail?.maSanPhamMoi || ''
            );

            // Template gộp nhiều thẻ cùng sản phẩm (amount/ids) -> tách lại từng thẻ theo id thật.
            // product.summaryId của template chỉ là gợi ý (các thẻ gộp có thể thuộc nhiều summary khác nhau)
            if (amount && ids) {
              return Array.from({ length: amount }, (_, k) => {
                const realId = ids[k] || 0;
                const rawForThisId = realId ? findRawDetail(realId) : undefined;
                return toPending(base, rawForThisId?.summaryId, product.summaryId, rawForThisId ?? rawDetail, {
                  id: realId
                });
              });
            }

            return [toPending(base, rawDetail?.summaryId || product.summaryId, 0, rawDetail)];
          });

        const collectFromProducts = (group: any): any[] =>
          (group.products || []).map((p: any) => {
            const product = { ...p };
            const rawDetail = findRawDetail(product.id);
            const base = buildBaseItem(
              group,
              product,
              rawDetail,
              product.maSanPhamMoi || rawDetail?.maSanPhamMoi || ''
            );
            return toPending(base, rawDetail?.summaryId || product.summaryId, 0, rawDetail);
          });

        const pendingUpgrades: any[] = (detailUpgrades || []).flatMap((group: any) => [
          ...collectFromDetails(group),
          ...collectFromProducts(group)
        ]);

        // Lượt 1: dòng đã gắn summary (detail thật / ruột của bộ) giữ nguyên summary gốc,
        // kể cả KT đổi sang SP khác (để KD biết mà duyệt/từ chối). Chiếm sức chứa trước fallback.
        pendingUpgrades.forEach(item => item._preferredId && markUsed(item._preferredId, item.maSanPhamMoi));

        // Lượt 2: dòng chưa gắn -> fallback theo sức chứa còn lại, rồi mới tính giá theo summary được cấp
        const allocatedUpgrades: any[] = pendingUpgrades.map(({ _preferredId, _hintId, _costSource, ...item }) => {
          const summaryId =
            _preferredId || pickFallbackSummaryId(_hintId, item.registrationPlate, item.companyId, item.maSanPhamMoi);
          return { ...item, ...resolveCostFields(_costSource, findSummaryById(summaryId)), summaryId };
        });

        // --- Hàng bộ: mọi thành phần (máy chính + ruột) phải gắn về summary BỘ gốc của KD ---
        // Thiếu setName/maBoSanPham thì backend coi ruột là SP KT đổi/thêm -> sinh summary requiresApproval
        // (KD mở đơn thấy thêm nhiều dòng sai). Đơn đã bị tách như vậy thì gắn ngược lại về summary bộ.
        const setSummaries = originalSummaries.filter(
          s => !s.requiresApproval && getSetInfo(productSetDataHaveDetails, s.maSanPhamMoi)
        );
        const normalizeSetMember = (item: any) => {
          const maSP = item.maSanPhamMoi || item.maSanPham || '';
          let summary = findSummaryById(item.summaryId);
          let info = getSetInfo(productSetDataHaveDetails, summary?.maSanPhamMoi);

          if (!info || !info.partCodes.includes(maSP)) {
            // chỉ gắn lại khi đang trỏ vào summary KT sinh ra (requiresApproval) hoặc chưa có summary
            if (summary && !summary.requiresApproval) return item;
            const owner = setSummaries.find(
              s =>
                s.registrationPlate === item.registrationPlate &&
                s.companyId === item.companyId &&
                getSetInfo(productSetDataHaveDetails, s.maSanPhamMoi)?.partCodes.includes(maSP)
            );
            if (!owner) return item;
            summary = owner;
            info = getSetInfo(productSetDataHaveDetails, owner.maSanPhamMoi);
          }

          // giá bộ nằm ở máy chính (có maSanPhamCu), ruột = 0 — cùng quy tắc syncCostSummaryToDetails
          const isMain = !!item.maSanPhamCu;
          return {
            ...item,
            summaryId: summary.id,
            setName: info!.set.description,
            maBoSanPham: info!.set.description,
            cost: isMain ? resolveNumber(summary.cost ?? 0) : 0,
            priceAfterVat: isMain ? resolveNumber(useVAT ? summary.priceAfterVat ?? 0 : summary.cost ?? 0) : 0,
            vatValue: isMain && useVAT ? resolveNumber(summary.vatValue ?? 0) : 0
          };
        };
        const upgrades: any[] = allocatedUpgrades.map(normalizeSetMember);

        // ==========================================================================
        // 3. VALIDATE + MAP VÀO BODY DETAILS
        // ==========================================================================
        const isMyTask = (upgrade: any) =>
          !hasMultipleTechs || upgrade.isChecked || upgrade.staffExecute === uLogin?.username;

        const isMissingRequiredData = (upgrade: any) =>
          isMyTask(upgrade) &&
          ((upgrade.isRequireSP == 1 && (!upgrade.serial || upgrade.serial.trim() === '')) ||
            (upgrade.isRequireSP == 2 && (!upgrade.phone || upgrade.phone.trim() === '')));

        if (upgrades.some(isMissingRequiredData)) {
          isNotEnoughData = true;
        }

        const resolveStaffExecute = (upgrade: any) => {
          if (upgrade?.staffExecute) return upgrade.staffExecute;
          if (hasMultipleTechs) return upgrade?.isChecked ? uLogin?.username : '';
          return uLogin?.username || '';
        };

        const normalizeHanDangKiem = (value: any) => {
          const isValidDate = moment(value)?.isValid() || value?._isValid;
          const validYear = Number((value + '').split('-')[0]) > 2010;
          return (
            (isValidDate && validYear
              ? Helpers.ConvertDateToISOString(new Date(value || '0001-01-01T23:00:00'), false)
              : null) || null
          );
        };

        body['details'] = upgrades.map(upgrade => {
          const finalMaSanPhamMoi = upgrade.maSanPhamMoi || upgrade.maSanPham || '';
          const finalMaSanPhamCu = upgrade.maSanPhamCu || '';

          const findSet = listProMix?.find(ps => ps.maSanPham === finalMaSanPhamMoi);

          // NGHIỆP VỤ: đã có summaryId (kể cả KT đổi sang SP khác tên) -> GIỮ summaryId gốc
          // để KD biết KT đã đổi SP nào mà duyệt/từ chối.
          // KHÔNG tạo summary tạm (dễ sinh double summaries). SP KT thêm/đổi cần người tạo đơn xác nhận
          // (điều kiện chung với Hoàn tất đơn) -> gom lại, bước kiểm tra cuối sẽ hỏi gửi yêu cầu cập nhật.
          if (
            finalMaSanPhamMoi !== '' &&
            isMyTask(upgrade) &&
            needsCreatorConfirm(upgrade, findSummaryById(upgrade.summaryId), productSetDataHaveDetails)
          ) {
            // chỉ để hiển thị trong modal/thông báo; body gửi lên vẫn dùng finalMaSanPhamMoi
            unconfirmedProducts.push(findSet?.description || finalMaSanPhamMoi);
          }

          return {
            ...upgrade,
            summaryId: upgrade.summaryId || 0,
            vehicleType: upgrade.vehicleType || '',
            registrationPlate: upgrade.registrationPlate || '',
            staffExecute: resolveStaffExecute(upgrade),

            // Đồng bộ key mã sản phẩm để mọi object trong details giống nhau
            maSanPham: finalMaSanPhamMoi,
            preMaSanPham: finalMaSanPhamCu,
            maSanPhamMoi: finalMaSanPhamMoi,
            maSanPhamCu: finalMaSanPhamCu,

            companyId: upgrade.companyId || 0,
            doiXe: upgrade.doiXe || '',
            priceAfterVat: useVAT ? upgrade.priceAfterVat ?? 0 : upgrade.cost ?? 0,
            vatValue: useVAT ? upgrade.vatValue ?? 0 : 0,
            hanDangKiem: normalizeHanDangKiem(upgrade.hanDangKiem)
          };
        });

        // ==========================================================================
        // 4. SUMMARIES: chỉ gửi summary gốc của KD
        // ==========================================================================
        // Bỏ summary KT sinh ra (requiresApproval) không còn detail nào dùng — vd: ruột bộ vừa gắn lại về summary bộ
        const usedSummaryIds = new Set(body['details'].map((d: any) => d.summaryId));
        body['summaries'] = originalSummaries
          .filter(s => !s.requiresApproval || usedSummaryIds.has(s.id))
          .map(s => ({ ...s, hanDangKiem: fixEmptyHanDangKiem(s.hanDangKiem) }));

        typeStatus = 'FinishUpgradeV2';
      }

      if (rowSelected?.orderType?.id == 8) {
        body['items'] = [];

        // dữ liệu gốc đầy đủ theo từng id (vatValue, priceAfterVat, oldCompanyId, oldHanDangKiem, newCompanyId, newHanDangKiem...)
        const rawOrderDetails = rowSelected?.orderDetails || [];
        const findRawDetail = id => rawOrderDetails.find(d => d.id === id);

        const replaces: any = [];
        for (let i = 0; i < detailReplace.length; i++) {
          if (detailReplace[i].products) {
            for (let j = 0; j < detailReplace[i].products.length; j++) {
              const product = { ...detailReplace[i].products[j] };
              const rawDetail = findRawDetail(product.id);

              const objDetail = {
                oldVehicleType: detailReplace[i]['oldVehicleType'] || rawDetail?.oldVehicleType || '',
                oldRegistrationPlate: detailReplace[i]['oldRegistrationPlate'] || rawDetail?.oldRegistrationPlate || '',
                oldCompanyId: detailReplace[i]['oldCompanyId'] || rawDetail?.oldCompanyId || 0,
                oldDoiXe: detailReplace[i]['oldDoiXe'] || rawDetail?.oldDoiXe || '',
                oldHanDangKiem: detailReplace[i]['oldHanDangKiem'] || rawDetail?.oldHanDangKiem || null,
                newVehicleType: detailReplace[i]['newVehicleType'] || rawDetail?.newVehicleType || '',
                newRegistrationPlate: detailReplace[i]['newRegistrationPlate'] || rawDetail?.newRegistrationPlate || '',
                newCompanyId: detailReplace[i]['newCompanyId'] || rawDetail?.newCompanyId || 0,
                newDoiXe: detailReplace[i]['newDoiXe'] || rawDetail?.newDoiXe || '',
                newHanDangKiem: detailReplace[i]['newHanDangKiem'] || rawDetail?.newHanDangKiem || null,
                staffExecute: detailReplace[i]['staffExecute'] || rawDetail?.staffExecute || '',
                note: detailReplace[i]['note'] || rawDetail?.note || '',
                ...product,
                // coi cả 0 là "chưa có giá trị" -> fallback về rawDetail rồi mới tới productMix
                cost: resolveNumber(rawDetail?.cost || 0),
                vatValue: resolveNumber(rawDetail?.vatValue || 0),
                priceAfterVat: resolveNumber(rawDetail?.priceAfterVat || 0)
              };
              replaces.push(objDetail);
              if (
                // sp thay thế
                (product.isRequireSP == 1 && (product.serial?.length == 0 || !product.serial)) ||
                (product.isRequireSP == 2 && (product.phone?.length == 0 || !product.phone))
              ) {
                isNotEnoughData = true;
              }
            }
          } else {
            replaces.push({
              ...detailReplace[i]
            });
          }

          if (detailReplace[i].details) {
            for (let j = 0; j < detailReplace[i].details.length; j++) {
              const product = { ...detailReplace[i].details[j] };
              const rawDetail = findRawDetail(product.id);

              const objDetail = {
                oldVehicleType: detailReplace[i]['oldVehicleType'] || rawDetail?.oldVehicleType || '',
                oldRegistrationPlate: detailReplace[i]['oldRegistrationPlate'] || rawDetail?.oldRegistrationPlate || '',
                oldCompanyId: detailReplace[i]['oldCompanyId'] || rawDetail?.oldCompanyId || 0,
                oldDoiXe: detailReplace[i]['oldDoiXe'] || rawDetail?.oldDoiXe || '',
                oldHanDangKiem:
                  ((moment(detailReplace[i]['oldHanDangKiem'])?.isValid() ||
                    detailReplace[i]['oldHanDangKiem']?._isValid) &&
                  Number((detailReplace[i]['oldHanDangKiem'] + '').split('-')[0]) > 2010
                    ? Helpers.ConvertDateToISOString(
                        new Date(detailReplace[i]['oldHanDangKiem'] || '0001-01-01T23:00:00'),
                        false
                      )
                    : null) ||
                  rawDetail?.oldHanDangKiem ||
                  null,
                newVehicleType: detailReplace[i]['newVehicleType'] || rawDetail?.newVehicleType || '',
                newRegistrationPlate: detailReplace[i]['newRegistrationPlate'] || rawDetail?.newRegistrationPlate || '',
                newCompanyId: detailReplace[i]['newCompanyId'] || rawDetail?.newCompanyId || 0,
                newDoiXe: detailReplace[i]['newDoiXe'] || rawDetail?.newDoiXe || '',
                newHanDangKiem:
                  ((moment(detailReplace[i]['newHanDangKiem'])?.isValid() ||
                    detailReplace[i]['newHanDangKiem']?._isValid) &&
                  Number((detailReplace[i]['newHanDangKiem'] + '').split('-')[0]) > 2010
                    ? Helpers.ConvertDateToISOString(
                        new Date(detailReplace[i]['newHanDangKiem'] || '0001-01-01T23:00:00'),
                        false
                      )
                    : null) ||
                  rawDetail?.newHanDangKiem ||
                  null,
                staffExecute: detailReplace[i]['staffExecute'] || rawDetail?.staffExecute || '',
                note: detailReplace[i]['note'] || rawDetail?.note || '',
                ...product,
                //  tính SAU spread
                // cost: resolveNumber(
                //   rawDetail?.cost ||
                //     (product.maSanPhamMoi && product.maSanPhamMoi != ''
                //       ? productMix.find(proMix => proMix.maSanPham == product.maSanPhamMoi)?.giaBanSi || 0
                //       : 0)
                // ),
                // tính SAU spread
                cost: resolveNumber(rawDetail?.cost || 0),
                vatValue: resolveNumber(rawDetail?.vatValue || 0),
                priceAfterVat: resolveNumber(rawDetail?.priceAfterVat || 0)
              };
              replaces.push(objDetail);
              if (
                // sp mới...
                (product.isRequireSPMoi == 1 && (product.serialMoi?.length == 0 || !product.serialMoi)) ||
                (product.isRequireSPMoi == 2 && (product.phoneMoi?.length == 0 || !product.phoneMoi))
              ) {
                isNotEnoughData = true;
              }
            }
          }
        }

        body['items'] = replaces.map(replace => ({
          ...replace,
          serial: keepByRequire(replace.isRequireSP, 1, replace.serial),
          phone: keepByRequire(replace.isRequireSP, 2, replace.phone),
          serialMoi: keepByRequire(replace.isRequireSPMoi, 1, replace.serialMoi),
          phoneMoi: keepByRequire(replace.isRequireSPMoi, 2, replace.phoneMoi),

          oldVehicleType: replace['oldVehicleType'] || '',
          oldRegistrationPlate: replace['oldRegistrationPlate'] || '',
          oldCompanyId: replace['oldCompanyId'] || 0,
          oldDoiXe: replace['oldDoiXe'] || '',
          newVehicleType: replace['newVehicleType'] || '',
          newRegistrationPlate: replace['newRegistrationPlate'] || '',
          newCompanyId: replace['newCompanyId'] || 0,
          newDoiXe: replace['newDoiXe'] || '',
          note: replace['note'] || '',
          // serial: replace['serial'] || '',
          maSanPham: replace['maSanPham'] || '',
          cost: replace['cost'] || 0,
          priceAfterVat: useVAT ? replace['priceAfterVat'] || 0 : replace['cost'] || 0,
          vatValue: useVAT ? replace['vatValue'] || 0 : 0,
          oldHanDangKiem:
            ((moment(replace.oldHanDangKiem)?.isValid() || replace.oldHanDangKiem?._isValid) &&
            Number((replace.oldHanDangKiem + '').split('-')[0]) > 2010
              ? Helpers.ConvertDateToISOString(new Date(replace.oldHanDangKiem || '0001-01-01T23:00:00'), false)
              : null) || null,
          newHanDangKiem:
            ((moment(replace.newHanDangKiem)?.isValid() || replace.newHanDangKiem?._isValid) &&
            Number((replace.newHanDangKiem + '').split('-')[0]) > 2010
              ? Helpers.ConvertDateToISOString(new Date(replace.newHanDangKiem || '0001-01-01T23:00:00'), false)
              : null) || null
        }));

        // có thêm bước check thiếu serial hoặc sđt thì k cho pass !!!
        typeStatus = 'FinishOrderThaoLapLai';
      }

      if (rowSelected?.orderType?.id == 11) {
        // có thêm bước check thiếu serial hoặc sđt thì k cho pass !!!
        typeStatus = 'FinishDebtOrder';
      }

      typeStatus && checkFormDetail && checkFormDetail();
      // cần kiểm tra các sản phẩm trong body có hay k nếu k có thì k gửi báo cần nhập chi tiết các tb

      // 1. Ưu tiên kiểm tra Biển số trước
      if (isNotEnoughBienSo) {
        console.log('Dừng: Thiếu biển số');
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.DataNotValidBienSo'), 'error');
        return; // Thoát hàm ngay lập tức
      }

      // 2. Sau đó mới kiểm tra dữ liệu chung (Serial/Phone...)
      if (isNotEnoughData) {
        console.log('dừng gọi api vì data k hợp lệ');
        showMessage(t('OrganizedSales.OrderManager.ModifyOrder.UpdateStatus.SubMsg.DataNotValid'), 'error');
        return;
      }

      // 3. Đơn nâng cấp: KT đổi/thêm SP không khớp summary nào của bên tạo đơn -> không gửi, hỏi gửi yêu cầu cập nhật
      if (unconfirmedProducts.length > 0) {
        if (rowSelected?.yeuCauChinhSua == 1) {
          warnWaitingCreator(unconfirmedProducts);
        } else if (await isUpgradeFinishNoSummaryOn()) {
          // Config bật: lưu toàn bộ detail (SP chưa khớp gửi summaryId = 0) rồi tự gửi YeuCauChinhSua
          confirmRequestUpdate(unconfirmedProducts, () =>
            handleActionStaff(typeStatus, body, 'Finished', rowSelected.maDonHang, 'checkRequest')
          );
        } else {
          // Config tắt: chặn, chỉ gửi YeuCauChinhSua
          askRequestUpdateOrder(rowSelected.maDonHang, unconfirmedProducts);
        }
        return;
      }

      // Nếu vượt qua cả 3, tiến hành gọi API...
      // console.log('check lại data body', body);
      typeStatus && handleActionStaff(typeStatus, body, 'Finished', rowSelected.maDonHang, type);
    },
    completeOrder: (note?: string, oldCompany?: string, moreInformation?: string) => {
      const body = {
        maDonHang: rowSelected.maDonHang,
        completeTime: Helpers.ConvertDateToISOString(new Date()),
        note: note || '',
        // hinhThucThanhToan: rowSelected.payment.hinhThucThanhToan, // các trường sau có thể thay đổi đó !!!
        // tienThucThu: 4500555,
        // nhưng mà kth thì k có sửa các thông tin khác trừ tiền thực thu và HTTT
        orderVat: {
          tenCongTy: companyName || rowSelected?.orderVat?.tenCongTy,
          mst: mst || rowSelected?.orderVat?.mst,
          address: address || rowSelected?.orderVat?.address,
          vatValue: (valueVAT != null && valueVAT != undefined && valueVAT) || rowSelected?.orderVat?.vatValue
        }
      };

      let typeStatus = null;

      if (rowSelected?.orderType?.id == 1 || rowSelected?.orderType?.id == 2 || rowSelected?.orderType?.id == 10) {
        typeStatus = 'Complete';
      }
      if (rowSelected?.orderType?.id == 4 || rowSelected?.orderType?.id == 5) {
        typeStatus = 'CompleteRepair';
        body['tienThanhToan'] = 0;
        body['tienThucThu'] = 0;
        body['chiPhiPhatSinh'] = 0;
        body['hinhThucThanhToan'] = '';
      }
      if (rowSelected?.orderType?.id == 6) {
        typeStatus = 'CompleteChangeCompany';
        body['oldCompany'] = oldCompany || '';
        body['moreInformation'] = moreInformation || '';
      }
      if (rowSelected?.orderType?.id == 7) {
        // Cùng điều kiện với Thực hiện xong: còn SP KT thêm/đổi chưa được người tạo đơn xác nhận
        // -> hỏi gửi yêu cầu cập nhật NGAY, không mở bảng xác nhận rồi mới bị server từ chối.
        const pendingProducts = findProductsNeedConfirm(rowSelected, productSetDataHaveDetails);
        if (pendingProducts.length > 0) {
          if (rowSelected?.yeuCauChinhSua == 1) warnWaitingCreator(pendingProducts);
          else askRequestUpdateOrder(rowSelected.maDonHang, pendingProducts);
          return;
        }

        typeStatus = 'CompleteUpgrade';
      }

      if (rowSelected?.orderType?.id == 3) {
        // console.log('Complete T.phí..', null);
        typeStatus = 'CompleteCollectFee';
      }
      if (rowSelected?.orderType?.id == 8) {
        console.log('Complete Tháo..', null);
        body['tienThanhToan'] = 0;
        body['tienThucThu'] = 0;
        body['chiPhiPhatSinh'] = 0;
        typeStatus = 'CompleteThaoLapLai';
        body['tienThucThu'] = 0;
        body['hinhThucThanhToan'] = '';
      }
      if (rowSelected?.orderType?.id == 11) {
        body['tienThucThu'] = rowSelected?.payment?.tienThucThu || 0;
        body['hinhThucThanhToan'] = rowSelected?.payment?.hinhThucThanhToan || '';
        typeStatus = 'CompleteDebtOrder';
      }
      // console.log({ typeStatus, rowSelected, body });
      const valueDetails = proccessDetailBase(rowSelected.itemDetails);
      dispatch(addCreateOrders({ typeStatus, body, rowSelected, valueDetails }));
      dispatch(updateOpenCreateModal(true));
      // handleActionStaff(typeStatus, body, 'Completed');
    }
  };

  const viewStaffAssignStatus = useMemo(() => {
    if (rowSelected?.executeInfo.length != 0 && uLogin.ActionOrder.viewStaffAction) {
      return rowSelected?.executeInfo.map(staff => (
        <div
          key={staff.staffExecute}
          style={{
            color:
              staff.status === 'Accept'
                ? 'rgb(22, 163, 74)'
                : staff.status === 'Wait'
                ? 'rgb(24, 144, 255)'
                : staff.status === 'Start'
                ? 'rgb(143,206,0)'
                : 'rgb(185 28 28)'
          }}
        >
          <span>{staff.staffExecute}</span>: <span>{staff.status}</span>
        </div>
      ));
    } else return <>{t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.NotAcceptView')}</>;
  }, [rowSelected?.executeInfo, uLogin]);

  const viewStaffInWait = useMemo(() => {
    if (uLogin.ActionOrder.viewStaffAction) {
      const listWait = rowSelected?.executeInfo.filter(staffF => staffF.status == 'Wait') || [];
      if (rowSelected?.executeInfo.length != 0 && listWait?.length != 0)
        return listWait.map(staff => <span key={staff.staffExecute}>{staff.staffExecute}; </span>);

      return null;
    }
    return rowSelected?.executeInfo?.length != 0 ? (
      <>{t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.NotAcceptView')}</>
    ) : null;
  }, [rowSelected?.executeInfo, uLogin]);

  return (
    <div className="p-1 bg-cyan-100  drop-shadow-sm">
      {/* đổi loại đơn thì k cần hiện */}
      {openCodeCreateModal && !isChangeTypeOrder && <ConfirmOrderModal typeOrder="xacnhandonhang" />}
      <div className="flex flex-col space-y-4">
        <div className="text-sx text-gray-500">
          <div className={classNames(CreateTime?.length !== 0 ? 'block' : 'hidden')}>
            {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.CreateTime')}:{' '}
            <span className="text-gray-600 font-semibold">{CreateTime}</span>
          </div>
          <div className={classNames(WorkTime?.length !== 0 ? 'block' : 'hidden')}>
            {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.WorkTime')}:{' '}
            <span className=" text-gray-600  font-semibold">{WorkTime}</span>
          </div>
          <div className={classNames(DoneTime?.length !== 0 ? 'block' : 'hidden')}>
            {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.DoneTime')}:{' '}
            <span className="text-gray-600  font-semibold">{DoneTime}</span>
          </div>
        </div>

        <div className="text-lg text-gray-500 flex flex-row">
          <span className="text-base font-semibold text-blue-500 pr-3">
            {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.CodeOrder')}: {rowSelected?.maDonHang}
          </span>
          <span
            style={{ backgroundColor: `${rowSelected?.status?.color}` }}
            className="relative text-base whitespace-nowrap text-white w-fit h-fit border rounded px-2"
          >
            {rowSelected?.status?.seen == false && (
              <div className="absolute w-[10px] h-[10px] bg-[#FFD23F] -top-[4px] -right-[4px]  rounded-full"></div>
            )}
            {t(rowSelected?.status?.text)}
          </span>
        </div>
        {rowSelected?.statusVNText === 'Hoàn tất' ? (
          uLogin?.role === 'Operating' && uLogin?.isHeadOfDepartment ? (
            ''
          ) : (
            <ViewImages data={rowSelected} />
          )
        ) : (
          ''
        )}

        {/* Ảnh người tạo đơn: mọi người xem ở mọi trạng thái; chỉ người tạo được sửa khi đơn chưa Hoàn tất/Huỷ.
            UploadImages tự ẩn khi chỉ xem mà không có ảnh. */}
        {rowSelected && (
          <UploadImages
            kind="creator"
            readOnly={!canEditCreatorImages(rowSelected, uLogin?.username)}
            rowSelected={rowSelected}
            data={rowSelected}
            status={rowSelected?.statusVNText}
            typeKeyOrder={typeKeyOrder}
          />
        )}

        {/* khi nào đơn đang tiến trình thì sẽ thấy sl các nv thực hiện | có thể cần sửa lại để khi đang điều cũng thấy mục này */}
        {WorkTime?.length !== 0 && (
          <>
            {rowSelected?.status?.statusValue === '2' && (
              <>
                <div className="text-sx text-gray-500">
                  {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.NumberStaffWork')}:{' '}
                  <span className="text-gray-600 font-semibold">
                    {rowSelected?.executeInfo.length}{' '}
                    <Tooltip title={viewStaffAssignStatus}>
                      <span className="btn-remove  hover:text-blue-500 hover:underline cursor-pointer">
                        {'Chi tiết thao tác'}
                      </span>
                    </Tooltip>
                  </span>{' '}
                  {/* cần hiện thêm các nv đã chấp nhận hay chưa cho nv điều hành biết !! */}
                </div>
              </>
            )}

            {viewStaffInWait && (
              <div className="text-sx text-gray-500">
                {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.StaffInWait')}:{' '}
                <span className="text-red-600 font-semibold">{viewStaffInWait}</span>
              </div>
            )}
          </>
        )}

        {/* nếu đơn bị từ chối do kto thì hiện lý do từ chối */}
        {rowSelected?.status?.statusValue === '6' && (
          <>
            <div className="text-sx text-gray-500">
              {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.ResionNotApprove')}:{' '}
              <span className="text-gray-600 font-semibold">{rowSelected?.notApproveInfo.note}</span>
            </div>
          </>
        )}

        {/* nếu cskh gọi xác nhận hoàn tất đơn thì sẽ có ghi chú hiện lên */}
        {!uLogin?.ActionOrder?.noViewFeedback &&
          rowSelected?.status?.statusValue === '4' &&
          rowSelected?.customerServiceCall.isCalled && (
            <>
              <div className="text-sx text-gray-500">
                {t('OrganizedSales.OrderManager.ModifyOrder.StatusOrder.NoteCSCall')}:{' '}
                <span className="text-green-600 font-semibold">{rowSelected?.customerServiceCall?.note}</span>
              </div>
            </>
          )}

        {rowSelected && !isChangeTypeOrder && (
          <OrderStatusActionStaff
            maDonHang={rowSelected?.maDonHang}
            yeuCauChinhSua={rowSelected?.yeuCauChinhSua}
            typeOrder={typeOrder}
            typeKeyOrder={typeKeyOrder}
            rowSelected={rowSelected}
            confirmOrder={rowSelected?.status || {}}
            modeAction={modeAction}
            type={type}
            actionEvents={actionStaffsEvents}
            isPrioritized={isPrioritized}
            setIsPrioritized={e => setIsPrioritized(e)}
            listStaffAssigned={rowSelected?.executeInfo || []}
            rejectInfo={rowSelected?.rejectInfo || []}
            branchWorkOrder={rowSelected.branchInfo.id}
            payment={rowSelected.payment}
            valueVat={valueVAT}
            outTimeUpdate={
              rowSelected?.status?.statusValue === '4' &&
              moment(rowSelected.times.thoiGianHoanThanh).add(timeData, 'days').isBefore(moment(), 'milliseconds')
            }
          />
        )}
      </div>

      {/* các thao tác từ chối // huỷ đơn cần nhập thông tin thêm để confirm thao tác  */}
      <DeleteOrderModal
        isOpen={openCanel}
        rowSelect={rowSelected}
        callBackClose={() => setOpenCancel(false)}
        callBackRefresh={() => setOpenCancel(false)}
        callBackDelete={callBackDelete}
      />
      <DeclineOrderModal
        isOpen={openDecline}
        rowSelect={rowSelected}
        callBackClose={() => setOpenDecline(false)}
        callBackRefresh={() => setOpenDecline(false)}
        callBackDelete={callBackDecline}
      />
    </div>
  );
}
